//frontend/src/admin/CargoManagement.js 
import React, { useState, useEffect } from 'react';
import { 
  FaPlus, FaSearch, FaFilter, FaEye, FaEdit, FaTrash,
  FaBox, FaBarcode, FaQrcode, FaUsers, FaTruck,
  FaWeight, FaCube, FaCalendarAlt, FaTimes, FaSave,
  FaInfoCircle, FaFileInvoice, FaWarehouse, FaExclamationTriangle,
  FaTag, FaMapMarkerAlt, FaImage, FaUpload, FaSyncAlt, FaPrint, FaCheckCircle,
  FaMoneyBillWave, FaGlobe, FaUser, FaHistory, FaSearchPlus, FaPhone, FaUndo,FaMobileAlt, FaClock, FaPencilAlt
} from 'react-icons/fa';
import JsBarcode from 'jsbarcode';
import axiosInstance from '../axios';
import { useAuth } from '../context/AuthContext';
import '../styles/admin.css';
import '../styles/custom.css';


  // ✅ Ачаа засах форм компонент - ШИНЭЧЛЭГДСЭН
      const CargoEditForm = ({ cargo, onSave, onCancel, canEditPrice, containers, paymentLocations }) => {
      const [formData, setFormData] = useState({
        cargo_name: cargo.cargo_name || '',
        sender_name: cargo.sender_name || '',
        sender_phone: cargo.sender_phone || '',
        sender_address: cargo.sender_address || '',
        receiver_name: cargo.receiver_name || '',
        receiver_phone: cargo.receiver_phone || '',
        receiver_address: cargo.receiver_address || '',
        cargo_type: cargo.cargo_type || 'weight',
        weight_kg: cargo.weight_kg || '',
        length_cm: cargo.length_cm || '',
        width_cm: cargo.width_cm || '',
        height_cm: cargo.height_cm || '',
        description: cargo.description || '',
        is_manual_price: cargo.is_manual_price || false,
        manual_price: cargo.manual_price || '',
        container_id: cargo.container_id || '',
        total_pieces: cargo.total_pieces || 1,
        payment_location_id: cargo.payment_location_id || ''
      });

      const previousPrice = cargo.price || 0;
      const currencySymbol = cargo.currency_code || '₮';

      const handleSubmit = (e) => {
        e.preventDefault();
        // console.log('📝 Form submit data:', formData);
        onSave(formData);
      };

      return (
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Үндсэн мэдээлэл */}
          <div className="bg-blue-50 p-4 rounded-lg border-2 border-blue-200">
            <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
              <FaBox className="text-blue-600" />
              Үндсэн мэдээлэл
            </h4>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Ачааны нэр
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  value={formData.cargo_name}
                  onChange={(e) => setFormData({...formData, cargo_name: e.target.value})}
                  placeholder="Ачааны нэр"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Чингэлэг
                </label>
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-white"
                  value={formData.container_id}
                  onChange={(e) => setFormData({...formData, container_id: e.target.value})}
                  required
                >
                  <option value="">Чингэлэг сонгоно уу</option>
                  
                  {/* ✅ Одоогийн чингэлэг байхгүй бол нэмэх */}
                  {cargo.container_id && !containers.find(c => c.id == cargo.container_id) && (
                    <option value={cargo.container_id} style={{ color: '#f59e0b', fontWeight: 'bold' }}>
                      {cargo.container_code} (Хаалттай - Одоогийн)
                    </option>
                  )}
                  
                  {containers.map((container) => (
                    <option key={container.id} value={container.id}>
                      {container.name || container.container_code}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Тоо ширхэг
                </label>
                <input
                  type="number"
                  min="1"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  value={formData.total_pieces}
                  onChange={(e) => setFormData({...formData, total_pieces: parseInt(e.target.value) || 1})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Төлбөр төлөх байршил
                </label>
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-white"
                  value={formData.payment_location_id}
                  onChange={(e) => setFormData({...formData, payment_location_id: e.target.value})}
                  required
                >
                  <option value="">Сонгоно уу</option>
                  {paymentLocations.map((loc) => (
                    <option key={loc.id} value={loc.id}>
                      {loc.location_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Илгээгч/Хүлээн авагч */}
          <div className="bg-green-50 p-4 rounded-lg border-2 border-green-200">
            <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
              <FaUser className="text-green-600" />
              Илгээгч / Хүлээн авагч
            </h4>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Илгээгч нэр *</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                  value={formData.sender_name}
                  onChange={(e) => setFormData({...formData, sender_name: e.target.value})}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Илгээгч утас</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                  value={formData.sender_phone}
                  onChange={(e) => setFormData({...formData, sender_phone: e.target.value})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Хүлээн авагч нэр *</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                  value={formData.receiver_name}
                  onChange={(e) => setFormData({...formData, receiver_name: e.target.value})}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Хүлээн авагч утас</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                  value={formData.receiver_phone}
                  onChange={(e) => setFormData({...formData, receiver_phone: e.target.value})}
                />
              </div>
            </div>
          </div>

          {/* Ачааны хэмжээ */}
          <div className="bg-purple-50 p-4 rounded-lg border-2 border-purple-200">
            <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
              <FaWeight className="text-purple-600" />
              Ачааны хэмжээ
            </h4>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ачааны төрөл</label>
                <select
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 bg-white"
                  value={formData.cargo_type}
                  onChange={(e) => setFormData({...formData, cargo_type: e.target.value})}
                >
                  <option value="weight">Жингээр</option>
                  <option value="volume">Эзлэхүүнээр</option>
                </select>
              </div>

              {formData.cargo_type === 'weight' ? (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Жин (кг)</label>
                  <input
                    type="number"
                    step="0.01"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500"
                    value={formData.weight_kg}
                    onChange={(e) => setFormData({...formData, weight_kg: e.target.value})}
                  />
                </div>
              ) : (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Урт (см)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500"
                      value={formData.length_cm}
                      onChange={(e) => setFormData({...formData, length_cm: e.target.value})}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Өргөн (см)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500"
                      value={formData.width_cm}
                      onChange={(e) => setFormData({...formData, width_cm: e.target.value})}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Өндөр (см)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500"
                      value={formData.height_cm}
                      onChange={(e) => setFormData({...formData, height_cm: e.target.value})}
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {/* Үнийн мэдээлэл */}
          <div className="bg-yellow-50 p-4 rounded-lg border-2 border-yellow-300">
            <h4 className="font-semibold text-gray-800 mb-3 flex items-center gap-2">
              <FaMoneyBillWave className="text-yellow-600" />
              Үнийн мэдээлэл
            </h4>
            
            <div className="mb-4 p-3 bg-blue-100 border border-blue-300 rounded-lg">
            <p className="text-sm text-blue-800">
              <strong>Өмнөх үнэ:</strong> {parseFloat(previousPrice).toLocaleString()} {currencySymbol}
            </p>
          </div>

            {canEditPrice ? (
              <>
                <div className="flex items-center space-x-2 mb-4">
                  <input
                    type="checkbox"
                    id="manual_price_edit"
                    checked={formData.is_manual_price}
                    onChange={(e) => setFormData({...formData, is_manual_price: e.target.checked})}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <label htmlFor="manual_price_edit" className="text-sm font-medium text-gray-700">
                    Гараас үнэ оруулах
                  </label>
                </div>

                {formData.is_manual_price && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Гараас үнэ ({currencySymbol})</label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500"
                      value={formData.manual_price}
                      onChange={(e) => setFormData({...formData, manual_price: e.target.value})}
                      placeholder="Гараас үнэ"
                    />
                  </div>
                )}
              </>
            ) : (
              <div className="p-3 bg-gray-100 border border-gray-300 rounded-lg text-center">
                <p className="text-sm text-gray-600">🔒 Үнийн мэдээлэл засах эрх байхгүй байна</p>
              </div>
            )}
          </div>

          {/* Тайлбар */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Тайлбар</label>
            <textarea
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              rows="3"
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              placeholder="Нэмэлт тайлбар..."
            />
          </div>

          {/* Товчнууд */}
          <div className="flex justify-end space-x-3 pt-4 border-t">
            <button
              type="button"
              onClick={onCancel}
              className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
            >
              Цуцлах
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
            >
              <FaSave />
              Хадгалах
            </button>
          </div>
        </form>
      );
    };



const CargoManagement = () => {
  const [cargos, setCargos] = useState([]);
  const [containers, setContainers] = useState([]);

  const { user, loading: authLoading } = useAuth();
  
  const hasPermission = (permission) => {
    if (!user || !Array.isArray(user.perms)) return false;
    if (user.role === 'system_admin') return true;
    return user.perms.includes(permission);
  };
  
  const canView = hasPermission('cargo:view');
  const canViewAll = hasPermission('cargo:view-all');
  const canCreate = hasPermission('cargo:create'); // ✅ ЭНЭ МӨРИЙГ НЭМЭХ
  const canEdit = hasPermission('cargo:edit');
  const canDelete = hasPermission('cargo:delete');
  const canEditPrice = hasPermission('cargo_edit_price');

  
  const [storageFees, setStorageFees] = useState([]);
  const [paymentLocations, setPaymentLocations] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedContainer, setSelectedContainer] = useState('all');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedCargo, setSelectedCargo] = useState(null);

  const [selectedRegisteredBy, setSelectedRegisteredBy] = useState('all'); // ✅ ШИНЭ
  const [users, setUsers] = useState([]); // ✅ Хэрэглэгчдийн жагсаалт

  // БАРИМТЫН ХЭВЛЭХ MODAL STATES
  const [showReceipt1Modal, setShowReceipt1Modal] = useState(false);
  const [showReceipt2Modal, setShowReceipt2Modal] = useState(false);
  const [showPrintDropdown, setShowPrintDropdown] = useState(null);
  const [newSelectedStatus, setNewSelectedStatus] = useState('');
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1, pageSize: 20 });
  // ✅ ШИНЭ: Хугацааны filter
  const [dateFilterType, setDateFilterType] = useState('last30'); // 'last30' | 'custom'
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  // ✅ ШИНЭ: Төлбөрийн байршил filter
  const [selectedPaymentLocation, setSelectedPaymentLocation] = useState('all');
  const [uploadingImage, setUploadingImage] = useState(false);
  const [isPrintMode, setIsPrintMode] = useState(false);
  
  // Image Modal States
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [modalImages, setModalImages] = useState([]);

  // History States
  const [cargoStatusHistory, setCargoStatusHistory] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);

  // Current User State
  const [currentUser, setCurrentUser] = useState(null);

  // Reverse Distribution States
  const [showReverseModal, setShowReverseModal] = useState(false);
  const [reverseReason, setReverseReason] = useState('');
  const [reversingCargo, setReversingCargo] = useState(false);

  

  // 🆕 SMS History States
  const [smsHistory, setSmsHistory] = useState([]);
  const [loadingSmsHistory, setLoadingSmsHistory] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingCargo, setEditingCargo] = useState(null);
  
  const [receiptInfo, setReceiptInfo] = useState({
  receipt_phone_korea_1: '',
  receipt_phone_korea_2: '',
  receipt_phone_korea_3: '',
  receipt_phone_mongolia_1: '',
  receipt_phone_mongolia_2: '',
  receipt_phone_mongolia_3: '',
  receipt_phone_other_1: '',
  receipt_phone_other_2: '',
  receipt_phone_other_3: '',
  receipt_bank1_name: '',
  receipt_bank1_account: '',
  receipt_bank2_name: '',
  receipt_bank2_account: '',
  receipt_account_holder: ''
});

  const [cargoForm, setCargoForm] = useState({
    container_id: '',
    cargo_name: '',
    sender_name: '',
    sender_phone: '',
    sender_address: '',
    receiver_name: '',
    receiver_phone: '',
    receiver_address: '',
    cargo_type: 'weight',
    weight_kg: '',
    length_cm: '',
    width_cm: '',
    height_cm: '',
    total_pieces: 1,
    storage_fee_id: '',
    payment_location_id: '',
    description: '',
    images: [],
    currency_code: '',
    is_manual_price: false,
    manual_price: ''
  });

  const [paymentData, setPaymentData] = useState({
  method: 'cash',
  receiver_phone: '',
  note: ''
});
  
  const [formErrors, setFormErrors] = useState({});
  const [calculatedPrice, setCalculatedPrice] = useState(null);

   const cargoStatuses = [
    { code: 'registered', name: 'Бүртгэгдсэн' },
    { code: 'delivered', name: 'Хүлээн авсан' },
    { code: 'distributed', name: 'Тараагдсан' }
  ];

  useEffect(() => {
    fetchCargos();
    fetchReceiptInfo();
    fetchContainers();
    fetchStorageFees();
    fetchPaymentLocations();
    fetchCurrencies();    
  }, [searchTerm, selectedStatus, selectedContainer, selectedRegisteredBy, dateFilterType, dateFrom, dateTo, selectedPaymentLocation, pagination.currentPage]);
    // ✅ Хэрэглэгчдийг татах
      useEffect(() => {
        const fetchUsers = async () => {
          try {
            const response = await axiosInstance.get('/api/users');
            if (response.data.success) {
              setUsers(response.data.data);
            }
          } catch (error) {
            console.error('Users fetch error:', error);
          }
        };
      
      fetchUsers();
    }, []);

  useEffect(() => {
  if (canViewAll) {
    const fetchUsers = async () => {
      try {
        const response = await axiosInstance.get('/api/users');
        if (response.data.success) {
          setUsers(response.data.data || []);
        }
      } catch (error) {
        console.error('Users fetch error:', error);
      }
    };
    fetchUsers();
  }
}, [canViewAll]);

 useEffect(() => {
  calculatePrice();
}, [
  cargoForm.container_id,
  cargoForm.cargo_type,
  cargoForm.weight_kg,
  cargoForm.length_cm,
  cargoForm.width_cm,
  cargoForm.height_cm,
  cargoForm.total_pieces,
  cargoForm.is_manual_price,
  cargoForm.manual_price
]);




// PRINT MODE
useEffect(() => {
  if (showDetailModal && isPrintMode) {
    window.print();
    setIsPrintMode(false);
  }
}, [showDetailModal, isPrintMode]);

// IMAGE MODAL KEYBOARD
useEffect(() => {
  if (!showImageModal) return;
  
  const handleKeyPress = (e) => {
    if (e.key === 'ArrowLeft') previousImage();
    if (e.key === 'ArrowRight') nextImage();
    if (e.key === 'Escape') setShowImageModal(false);
  };
  
  window.addEventListener('keydown', handleKeyPress);
  return () => window.removeEventListener('keydown', handleKeyPress);
}, [showImageModal, selectedImageIndex, modalImages]);

// FETCH CURRENT USER
useEffect(() => {
  const fetchCurrentUser = async () => {
    try {
      const response = await axiosInstance.get('/api/auth/me');
      setCurrentUser(response.data);
    } catch (error) {
      console.error('Get user error:', error);
    }
  };
  fetchCurrentUser();
}, []);

  const calculatePrice = () => {
  if (!cargoForm.container_id) {
    setCalculatedPrice(null);
    return;
  }

  



  // ШИНЭ: Гараас оруулсан бол manual_price-г ашигла
  if (cargoForm.is_manual_price) {
    const totalPrice = parseFloat(cargoForm.manual_price || 0).toFixed(2);
    const container = containers.find(c => c.id == cargoForm.container_id);
    const currencyCode = getCurrencyCode(container?.currency_id);
    setCalculatedPrice({
      totalPrice,
      pieces: cargoForm.total_pieces,
      currency: currencyCode
    });
    return;
  }

  // Автомат тооцоолол (хуучнаар үлдээв)
  const container = containers.find(c => c.id == cargoForm.container_id);
  if (!container) return;
  let unitPrice = 0;
  if (cargoForm.cargo_type === 'weight' && cargoForm.weight_kg) {
    unitPrice = parseFloat(cargoForm.weight_kg) * parseFloat(container.price_per_kg);
  } else if (cargoForm.cargo_type === 'volume' && cargoForm.length_cm && cargoForm.width_cm && cargoForm.height_cm) {
    const volume = (parseFloat(cargoForm.length_cm) * parseFloat(cargoForm.width_cm) * parseFloat(cargoForm.height_cm)) / 1000000;
    unitPrice = volume * parseFloat(container.price_per_cbm);
  }
  const totalPrice = unitPrice.toFixed(2);
  const currencyCode = getCurrencyCode(container.currency_id);
  setCalculatedPrice({
    totalPrice,
    pieces: cargoForm.total_pieces,
    currency: currencyCode
  });
};
  const fetchCargos = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append('page', pagination.currentPage);
      params.append('page_size', pagination.pageSize);
      if (selectedStatus !== 'all') params.append('status', selectedStatus);
      if (selectedContainer !== 'all') params.append('container_id', selectedContainer);
      if (searchTerm) params.append('search', searchTerm);
      if (selectedRegisteredBy !== 'all') params.append('registered_by', selectedRegisteredBy);
      
      // ✅ ШИНЭ: Хугацааны filter
      if (dateFilterType === 'last30') {
        params.append('date_filter', 'last30');
      } else if (dateFilterType === 'custom' && dateFrom && dateTo) {
        params.append('date_from', dateFrom);
        params.append('date_to', dateTo);
      }
      
      // ✅ ШИНЭ: Төлбөрийн байршил filter (code-аар)
      if (selectedPaymentLocation !== 'all') {
        params.append('payment_location_code', selectedPaymentLocation);
      }

      const response = await axiosInstance.get(`/api/cargo-new?${params}`);
      if (response.data.success) {
        const cargosData = response.data.data || [];
        cargosData.forEach(cargo => {
          if (cargo.images) {
            try {
              cargo.images = JSON.parse(cargo.images);
            } catch (e) {
              cargo.images = [];
            }
          } else {
            cargo.images = [];
          }
        });
        setCargos(cargosData);
        setPagination({
          ...pagination,
          totalPages: response.data.total_pages || 1,
          totalItems: response.data.total_items || 0
        });
      }
    } catch (error) {
      console.error('Cargo fetch error:', error);
      setCargos([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchContainers = async () => {
    try {
      const response = await axiosInstance.get('/api/containers-new/available');
      if (response.data.success) {
        setContainers(response.data.data || []);
      }
    } catch (error) {
      console.error('Containers fetch error:', error);
    }
  };

  const fetchStorageFees = async () => {
    try {
      const response = await axiosInstance.get('/api/storage-fees');
      if (response.data.success) {
        setStorageFees(response.data.data || []);
      }
    } catch (error) {
      console.error('Storage fees fetch error:', error);
    }
  };

  const fetchPaymentLocations = async () => {
    try {
      const response = await axiosInstance.get('/api/payment-locations');
      if (response.data.success) {
        setPaymentLocations(response.data.data || []);
      }
    } catch (error) {
      console.error('Payment locations fetch error:', error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const response = await axiosInstance.get('/api/payment-currencies');
      if (response.data.success) {
        setCurrencies(response.data.data || []);
      }
    } catch (error) {
      console.error('Currencies fetch error:', error);
    }
  };

  const fetchCargoHistory = async (cargoId) => {
    setLoadingHistory(true);
    try {
      const response = await axiosInstance.get(`/api/cargo-new/${cargoId}/history`);
      if (response.data.success) {
        setCargoStatusHistory(response.data.data || []);
      }
    } catch (error) {
      console.error('History fetch error:', error);
      setCargoStatusHistory([]);
    } finally {
      setLoadingHistory(false);
    }
  };

  



  const handleReverseDistribution = async () => {
    if (!reverseReason.trim()) {
      alert('Буцаах шалтгаан оруулна уу');
      return;
    }
    
    if (!window.confirm('⚠️ Та итгэлтэй байна уу?\n\nЭнэ үйлдэл:\n• Төлбөрийн бүртгэлийг устгана\n• Ачааг "Тараагдаагүй" төлөвт буцаана\n\nДавтан тараах боломжтой болно.')) {
      return;
    }
    
    setReversingCargo(true);
    try {
      const response = await axiosInstance.patch(
        `/api/cargo-new/${selectedCargo.id}/reverse-distribution`,
        { reason: reverseReason }
      );
      
      if (response.data.success) {
        alert('✅ Тараалт амжилттай буцаагдлаа!\n\nТөлбөрийн бүртгэл устгагдсан.');
        setShowReverseModal(false);
        setReverseReason('');
        setShowDetailModal(false);
        fetchCargos();
      }
    } catch (error) {
      console.error('Reverse distribution error:', error);
      alert(error.response?.data?.msg || 'Тараалт буцаахад алдаа гарлаа');
    } finally {
      setReversingCargo(false);
    }
  };

  const getCurrencyCode = (currencyId) => {
    if (!currencyId) return '';
    const currency = currencies.find(c => c.id == currencyId);
    return currency ? currency.currency_code : '';
  };

  const formatCurrency = (amount, currencyCode) => {
    if (!amount) return `0${currencyCode || ''}`;
    return `${parseFloat(amount).toLocaleString()}${currencyCode || ''}`;
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      alert('Зөвхөн зураг файл сонгоно уу!');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('Зургийн хэмжээ 5MB-с бага байх ёстой!');
      return;
    }
    setUploadingImage(true);
    try {
      const formData = new FormData();
      formData.append('image', file);
      const response = await axiosInstance.post('/api/upload-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (response.data.success) {
        setCargoForm({
          ...cargoForm,
          images: [...cargoForm.images, response.data.imageUrl]
        });
      }
    } catch (error) {
      console.error('Image upload error:', error);
      alert(error.response?.data?.msg || 'Зураг хуулахад алдаа гарлаа');
    } finally {
      setUploadingImage(false);
      e.target.value = '';
    }
  };

  const removeImage = async (index, imageUrl) => {
    try {
      await axiosInstance.delete('/api/delete-image', { data: { imageUrl } });
      const newImages = [...cargoForm.images];
      newImages.splice(index, 1);
      setCargoForm({ ...cargoForm, images: newImages });
    } catch (error) {
      console.error('Image delete error:', error);
      const newImages = [...cargoForm.images];
      newImages.splice(index, 1);
      setCargoForm({ ...cargoForm, images: newImages });
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!cargoForm.container_id) errors.container_id = 'Чингэлэг заавал сонгоно уу';
    if (!cargoForm.sender_name.trim()) errors.sender_name = 'Илгээгчийн нэр оруулна уу';
    if (!cargoForm.receiver_name.trim()) errors.receiver_name = 'Хүлээн авагчийн нэр оруулна уу';
     if (!cargoForm.storage_fee_id) errors.storage_fee_id = 'Хадгалалтын төрөл заавал сонгоно уу';
    
    if (cargoForm.is_manual_price) {
      if (!cargoForm.manual_price || parseFloat(cargoForm.manual_price) <= 0) {
        errors.manual_price = 'Үнэ зөв оруулна уу';
      }
    } else {
      if (cargoForm.cargo_type === 'weight') {
        if (!cargoForm.weight_kg || parseFloat(cargoForm.weight_kg) <= 0) {
          errors.weight_kg = 'Жинг зөв оруулна уу';
        }
      } else if (cargoForm.cargo_type === 'volume') {
        if (!cargoForm.length_cm || parseFloat(cargoForm.length_cm) <= 0) errors.length_cm = 'Урт оруулна уу';
        if (!cargoForm.width_cm || parseFloat(cargoForm.width_cm) <= 0) errors.width_cm = 'Өргөн оруулна уу';
        if (!cargoForm.height_cm || parseFloat(cargoForm.height_cm) <= 0) errors.height_cm = 'Өндөр оруулна уу';
      }
    }
    
    if (!cargoForm.total_pieces || parseInt(cargoForm.total_pieces) < 1) {
      errors.total_pieces = 'Ширхэг 1-с дээш байна';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddCargo = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      const { batch_number, ...formDataWithoutBatch } = cargoForm;
      const requestData = {
        ...formDataWithoutBatch,
        is_manual_price: cargoForm.is_manual_price ? 1 : 0,
        manual_price: cargoForm.is_manual_price ? parseFloat(cargoForm.manual_price) : null
      };
      
      const response = await axiosInstance.post('/api/cargo-new', requestData);
  
      if (response.data.success) {
        const container = containers.find(c => c.id == cargoForm.container_id);
        const currencySymbol = getCurrencyCode(container?.currency_id);
        alert(`Амжилттай бүртгэгдлээ!\n\nБагц: ${response.data.batch_number}\nШирхэг: ${response.data.cargo_codes.length}\nНийт үнэ: ${response.data.total_price.toLocaleString()}${currencySymbol}`);
    
        setShowAddModal(false);
        resetForm();
        fetchCargos();
      }
    } catch (error) {
      console.error('Add cargo error:', error);
      alert(error.response?.data?.msg || 'Ачаа бүртгэхэд алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCargo = async (id) => {
    if (!window.confirm('Энэ ачааг устгахдаа итгэлтэй байна уу?')) return;
    setLoading(true);
    try {
      const response = await axiosInstance.delete(`/api/cargo-new/${id}`);
      if (response.data.success) {
        alert('Ачаа амжилттай устгагдлаа');
        fetchCargos();
      }
    } catch (error) {
      console.error('Delete error:', error);
      alert(error.response?.data?.msg || 'Устгахад алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async () => {
  if (!newSelectedStatus) return;
 
  // Distributed төлөвт шилжих үед төлбөрийн хэлбэр шаардлагатай
  if (newSelectedStatus === 'distributed' && selectedCargo.status !== 'distributed') {
    if (!paymentData.method) {
      alert('Төлбөрийн хэлбэр сонгоно уу!');
      return;
    }
  }
 
  try {
    const requestData = {
      status: newSelectedStatus,
      payment_method: paymentData.method,
      receiver_phone_verified: paymentData.receiver_phone || selectedCargo.receiver_phone,
      note: paymentData.note  // 🆕 НЭМЭГДСЭН
    };
   
    const response = await axiosInstance.patch(
      `/api/cargo-new/${selectedCargo.id}/status`,
      requestData
    );
   
    if (response.data.success) {
      if (response.data.payment_recorded) {
        alert('✅ Төлөв шинэчлэгдэж, төлбөр бүртгэгдлээ!');
      } else {
        alert('Төлөв амжилттай шинэчлэгдлээ');
      }
      setShowStatusModal(false);
      setNewSelectedStatus('');
      setPaymentData({ method: 'cash', receiver_phone: '' });
      fetchCargos();
      // ЗАСВАР: Өөрчилсний дараа selectedCargo-г refetch хийж, detail modal-д шинэчлэх (хадгалалт зөв гарах)
      const detailResponse = await axiosInstance.get(`/api/cargo-new/${selectedCargo.id}`);
      if (detailResponse.data.success) {
        const data = detailResponse.data.data;
        data.cargo_codes = detailResponse.data.batch_cargos.map(b => b.cargo_code) || [data.cargo_code];
        setSelectedCargo(data);
      }
    }
  } catch (error) {
    console.error('Status change error:', error);
    // ЗАСВАР: Error handling сайжруулж, илүү мэдээлэл харуулах
    const errorMsg = error.response?.data?.msg || 'Төлөв өөрчлөхөд алдаа гарлаа (серверээс хариу алга)';
    alert(errorMsg);
  }
};

  const openDetailModal = async (cargo) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/api/cargo-new/${cargo.id}`);
      if (response.data.success) {
        const data = response.data.data;
        data.cargo_codes = response.data.batch_cargos.map(b => b.cargo_code) || [data.cargo_code];
        setSelectedCargo(data);
        setShowDetailModal(true);
        // Төлөвийн түүх татах
        await fetchCargoHistory(cargo.id);
        fetchSmsHistory(cargo.id);
      }
    } catch (error) {
      console.error('Fetch detail error:', error);
      alert('Дэлгэрэнгүй мэдээлэл авахад алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

    // SMS ТҮҮХ ТАТАХ
    const fetchSmsHistory = async (cargoId) => {
      setLoadingSmsHistory(true);
      try {
        const response = await axiosInstance.get(`/api/cargo-new/${cargoId}/sms-history`);
        if (response.data.success) {
          setSmsHistory(response.data.data || []);
        }
      } catch (error) {
        console.error('SMS history fetch error:', error);
        setSmsHistory([]);
      } finally {
        setLoadingSmsHistory(false);
      }
    };

  // ХЭВЛЭХ DROPDOWN TOGGLE
    const handlePrintToggle = (cargoId) => {
      setShowPrintDropdown(showPrintDropdown === cargoId ? null : cargoId);
    };

      // БАРИМТ-1 ХЭВЛЭХ
      const handlePrintReceipt1 = async (cargo) => {
        setShowPrintDropdown(null);
        setLoading(true);
        try {
          const response = await axiosInstance.get(`/api/cargo-new/${cargo.id}`);
          if (response.data.success) {
            const data = response.data.data;
            data.cargo_codes = response.data.batch_cargos.map(b => b.cargo_code) || [data.cargo_code];
            setSelectedCargo(data);
            setShowReceipt1Modal(true);
          }
        } catch (error) {
          console.error('Fetch detail error:', error);
          alert('Дэлгэрэнгүй мэдээлэл авахад алдаа гарлаа');
        } finally {
          setLoading(false);
        }
      };

        // БАРИМТ-2 ХЭВЛЭХ
        const handlePrintReceipt2 = async (cargo) => {
          setShowPrintDropdown(null);
          setLoading(true);
          try {
            const response = await axiosInstance.get(`/api/cargo-new/${cargo.id}`);
            if (response.data.success) {
              const data = response.data.data;
              data.cargo_codes = response.data.batch_cargos.map(b => b.cargo_code) || [data.cargo_code];
              setSelectedCargo(data);
              setShowReceipt2Modal(true);
            }
          } catch (error) {
            console.error('Fetch detail error:', error);
            alert('Дэлгэрэнгүй мэдээлэл авахад алдаа гарлаа');
          } finally {
            setLoading(false);
          }
        };

  const openStatusModal = async (cargo) => {
    setSelectedCargo(cargo);
    setNewSelectedStatus(cargo.status);
    setShowStatusModal(true);
    
    // Дэлгэрэнгүй мэдээлэл + storage fee тооцоолох
    try {
      const response = await axiosInstance.get(`/api/cargo-new/${cargo.id}`);
      if (response.data.success) {
        setSelectedCargo(response.data.data);
      }
    } catch (error) {
      console.error('Fetch cargo detail error:', error);
    }
  };

  const openImageModal = (images, index = 0) => {
    setModalImages(images);
    setSelectedImageIndex(index);
    setShowImageModal(true);
  };

  const nextImage = () => {
    setSelectedImageIndex((prev) => (prev + 1) % modalImages.length);
  };

  const previousImage = () => {
    setSelectedImageIndex((prev) => (prev - 1 + modalImages.length) % modalImages.length);
  };

  useEffect(() => {
    if (showDetailModal && selectedCargo && selectedCargo.cargo_codes) {
      selectedCargo.cargo_codes.forEach((code, index) => {
        const barcodeElement = document.getElementById(`barcode-${index}`);
        if (barcodeElement) {
          JsBarcode(barcodeElement, code, {
            format: "CODE128",
            lineColor: "#000000",
            width: 2,
            height: 80,
            fontSize: 14,
            displayValue: true,
            textMargin: 4,
            margin: 5
          });
        }
      });
    }
  }, [showDetailModal, selectedCargo]);

  // БАРИМТ-2 БАРКОД ҮҮСГЭХ - ЭНД НЭМНЭ
useEffect(() => {
  if (showReceipt2Modal && selectedCargo && selectedCargo.cargo_codes) {
    selectedCargo.cargo_codes.forEach((code, index) => {
      setTimeout(() => {
        const barcodeElement = document.getElementById(`receipt2-barcode-${index}`);
        if (barcodeElement) {
          // Баркодод зөвхөн код гаргах (cargo_code-гүй)
          JsBarcode(barcodeElement, code, {
            format: "CODE128",
            lineColor: "#000000",
            width: 1.5,
            height: 50,
            fontSize: 10,
            displayValue: false,
            margin: 2
          });
        }
      }, 50 * index);
    });
  }
}, [showReceipt2Modal, selectedCargo]);


  const resetForm = () => {
    setCargoForm({
      container_id: '',
      cargo_name: '',
      sender_name: '',
      sender_phone: '',
      sender_address: '',
      receiver_name: '',
      receiver_phone: '',
      receiver_address: '',
      cargo_type: 'weight',
      weight_kg: '',
      length_cm: '',
      width_cm: '',
      height_cm: '',
      total_pieces: 1,
      storage_fee_id: '',
      payment_location_id: '',
      description: '',
      images: [],
      currency_code: '',
      is_manual_price: false,
      manual_price: '',
      batch_number: ''
    });
    setFormErrors({});
    setCalculatedPrice(null);
  };

    const getStatusBadge = (status) => {
    const statusMap = {
      'registered': { class: 'badge-primary', text: 'Бүртгэгдсэн' },
      'delivered': { class: 'badge-info', text: 'Хүлээн авсан' },
      'distributed': { class: 'badge-success', text: 'Тараагдсан' }
    };
    const info = statusMap[status] || { class: 'badge-secondary', text: status };
    return <span className={`badge ${info.class}`}>{info.text}</span>;
  };

    const getStatusLabel = (statusCode) => {
    const statusMap = {
      'registered': 'Бүртгэгдсэн',
      'delivered': 'Хүлээн авсан',
      'distributed': 'Тараагдсан'
    };
    return statusMap[statusCode] || statusCode;
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setPagination({ ...pagination, currentPage: newPage });
    }
  };

  // ✅ Ачаа засах функц
    const handleEditCargo = async (cargo) => {
      try {
        // Дэлгэрэнгүй мэдээлэл татах
        const response = await axiosInstance.get(`/api/cargo-new/${cargo.id}`);
        if (response.data.success) {
          setEditingCargo(response.data.data);
          setShowEditModal(true);
        }
      } catch (error) {
        console.error('Fetch cargo error:', error);
        alert('Ачааны мэдээлэл татахад алдаа гарлаа');
      }
    };

    // ✅ Засвар хадгалах функц
    const handleSaveEdit = async (formData) => {
      if (!editingCargo) return;
      
      try {
        // console.log('📤 Sending data:', formData);
        
        const response = await axiosInstance.put(
          `/api/cargo-new/${editingCargo.id}`,
          formData
        );
        
        // console.log('📥 Response:', response.data);
        
        if (response.data.success) {
          alert('✅ Ачаа амжилттай шинэчлэгдлээ');
          setShowEditModal(false);
          setEditingCargo(null);
          fetchCargos();
        }
      } catch (error) {
        console.error('❌ Update cargo error:', error);
        console.error('Error response:', error.response?.data);
        const errorMsg = error.response?.data?.msg || error.response?.data?.error || 'Ачаа засахад алдаа гарлаа';
        alert('❌ ' + errorMsg);
      }
    };

    const fetchReceiptInfo = async () => {
  try {
    const response = await axiosInstance.get(`/api/receipt-info/public?_=${Date.now()}`);
    if (response.data.success) {
      setReceiptInfo({
        receipt_phone_korea_1: response.data.data.receipt_phone_korea_1 || '',
        receipt_phone_korea_2: response.data.data.receipt_phone_korea_2 || '',
        receipt_phone_korea_3: response.data.data.receipt_phone_korea_3 || '',
        receipt_phone_mongolia_1: response.data.data.receipt_phone_mongolia_1 || '',
        receipt_phone_mongolia_2: response.data.data.receipt_phone_mongolia_2 || '',
        receipt_phone_mongolia_3: response.data.data.receipt_phone_mongolia_3 || '',
        receipt_phone_other_1: response.data.data.receipt_phone_other_1 || '',
        receipt_phone_other_2: response.data.data.receipt_phone_other_2 || '',
        receipt_phone_other_3: response.data.data.receipt_phone_other_3 || '',
        receipt_bank1_name: response.data.data.receipt_bank1_name || '',
        receipt_bank1_account: response.data.data.receipt_bank1_account || '',
        receipt_bank2_name: response.data.data.receipt_bank2_name || '',
        receipt_bank2_account: response.data.data.receipt_bank2_account || '',
        receipt_account_holder: response.data.data.receipt_account_holder || ''
      });
    }
  } catch (error) {
    console.error('Fetch receipt info error:', error);
  }
};

  const getCurrencySymbol = (cargo) => {
    return cargo.currency_code || cargo.price_currency_code || '';
  };

  const getStorageFeeName = (id) => {
    const fee = storageFees.find(f => f.id == id);
    return fee ? `${fee.fee_name} - ${Number(fee.price_per_day).toLocaleString()}${getCurrencyCode(fee.currency_id)}/${fee.unit_type === 'per_piece' ? 'ширхэг' : fee.unit_type === 'per_kg' ? 'кг' : 'м³'}` : '-';
  };

  const getPaymentLocationName = (id) => {
    const loc = paymentLocations.find(l => l.id == id);
    return loc ? `${loc.location_name} (${getCurrencyCode(loc.currency_id)})` : '-';
  };

  const formatDate = (dateStr) => {
    return dateStr ? new Date(dateStr).toLocaleDateString('mn-MN', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-';
  };

  if (authLoading) {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Ачааллаж байна...</p>
      </div>
    </div>
  );
}

// ✅ ЗӨВХӨН ЭНЭ МӨР ӨӨРЧЛӨГДСӨН: !canView → !canView && !canCreate
if (!canView && !canCreate) {
  return (
    <div className="p-4 md:p-6">
      <h1 className="text-2xl font-bold mb-4">Ачаа удирдлага</h1>
      <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
        <div className="text-5xl mb-4">🔒</div>
        <p className="text-red-600 font-semibold text-lg">Эрх хүрэхгүй байна</p>
        <p className="text-gray-600 mt-2">Ачаа үүсгэх эсвэл харах эрх хэрэгтэй.</p>
      </div>
    </div>
  );
}


  return (
    <div className="cargo-management min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="mb-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2 flex items-center">
              <FaBox className="mr-3 text-blue-600" />
              Ачаа удирдлага
            </h1>
            <p className="text-sm text-gray-600">Ачааны бүртгэл, хяналт, удирдлага</p>
          </div>
          {canCreate && ( // ✅ cargo:create эрхтэй бол харагдана
          <button
            onClick={() => setShowAddModal(true)}
            className="custom-button flex items-center space-x-2 px-4 py-2"
          >
            <FaPlus className="mr-2" />
            Шинэ ачаа нэмэх
          </button>
            )}
        </div>
      </div>

      
      {/* FILTERS */}
      <div className="filters-section mb-6">
        {/* Хайлт */}
        <div className="flex flex-col sm:flex-row gap-4 mb-4">
          <div className="relative flex-1">
            <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Утас, ачааны код, нэрээр хайх..."
              className="w-full pl-11 pr-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white shadow-sm text-sm"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Filter-үүд */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
          <div className="flex flex-wrap items-center gap-3">
            <select
              className="w-40 px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white hover:border-gray-300 focus:ring-2 focus:ring-blue-500 cursor-pointer"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="all">Бүх төлөв</option>
              {cargoStatuses.map(status => (
                <option key={status.code} value={status.code}>{status.name}</option>
              ))}
            </select>

            <select
              className="w-52 px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white hover:border-gray-300 focus:ring-2 focus:ring-blue-500 cursor-pointer"
              value={selectedContainer}
              onChange={(e) => setSelectedContainer(e.target.value)}
            >
              <option value="all">Бүх чингэлэг</option>
              {containers.filter(c => c.status !== 'closed').map((container) => (
                <option key={container.id} value={container.id}>
                  {container.name || container.container_code} ({container.status === 'open' ? 'Нээлттэй' : 'Тооцоо'})
                </option>
              ))}
            </select>

            <select
              className="w-44 px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white hover:border-gray-300 focus:ring-2 focus:ring-blue-500 cursor-pointer"
              value={selectedRegisteredBy}
              onChange={(e) => setSelectedRegisteredBy(e.target.value)}
            >
              <option value="all">Бүх хэрэглэгч</option>
              {users.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.fullname || user.username}
                </option>
              ))}
            </select>

            <select
              className="w-48 px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white hover:border-gray-300 focus:ring-2 focus:ring-blue-500 cursor-pointer"
              value={selectedPaymentLocation}
              onChange={(e) => setSelectedPaymentLocation(e.target.value)}
            >
              <option value="all">Төлбөрийн байршил</option>
              {paymentLocations.map((loc) => (
                <option key={loc.id} value={loc.location_code}>
                  {loc.location_name}
                </option>
              ))}
            </select>

            <div className="h-6 w-px bg-gray-300 mx-1"></div>

            <select
              className="w-44 px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white hover:border-gray-300 focus:ring-2 focus:ring-blue-500 cursor-pointer"
              value={dateFilterType}
              onChange={(e) => setDateFilterType(e.target.value)}
            >
              <option value="last30">Сүүлийн 30 хоног</option>
              <option value="custom">Хугацаа сонгох</option>
              <option value="all">Бүх хугацаа</option>
            </select>

            {dateFilterType === 'custom' && (
              <div className="flex items-center gap-2 bg-blue-50 px-3 py-1.5 rounded-lg border border-blue-200">
                <input
                  type="date"
                  className="px-2 py-1.5 border border-blue-200 rounded text-sm bg-white focus:ring-2 focus:ring-blue-500"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
                <span className="text-blue-500 text-sm font-medium">→</span>
                <input
                  type="date"
                  className="px-2 py-1.5 border border-blue-200 rounded text-sm bg-white focus:ring-2 focus:ring-blue-500"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </div>
            )}
          </div>
        </div>
      </div>


      
      <div className="table-container bg-white rounded-lg shadow overflow-hidden">
        <div className="table-header px-4 py-3 border-b">
          <h2 className="table-title">Ачааны жагсаалт</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="data-table w-full">
            <thead>
              <tr>
                <th className="px-4 py-3">Ачааны код</th>
                <th className="px-4 py-3">Илгээгч</th>
                <th className="px-4 py-3">Хүлээн авагч</th>
                <th className="px-4 py-3">Тоо/Ширхэг</th>
                <th className="px-4 py-3">Төрөл</th>
                <th className="px-4 py-3">Жин/Эзлэхүүн</th>
                {paymentLocations.map((loc) => (
                  <th key={loc.location_code} className="px-4 py-3">{loc.location_name} үнэ</th>
                ))}
                <th className="px-4 py-3">Чингэлэг</th>
                
                <th className="px-4 py-3">Төлөв</th>
                <th className="px-4 py-3">Тараагдсан огноо</th>
                <th className="px-4 py-3">Үйлдэл</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
              <tr>
                <td colSpan="13" className="text-center py-8">
                  <div className="loading-spinner mx-auto"></div>
                  <p className="mt-2 text-gray-500">Ачааллаж байна...</p>
                </td>
              </tr>
              ) : cargos.length === 0 ? (
              <tr>
                <td colSpan="14" className="text-center py-8 text-gray-500">
                  Ачаа олдсонгүй
                </td>
              </tr>
              ) : (
                cargos.map((cargo) => (
                  <tr key={cargo.id} className="hover:bg-gray-50">
                    {/* 1. АЧААНЫ КОД - Дарахад дэлгэрэнгүй нээнэ */}
                    <td className="px-4 py-3 font-mono text-sm">
                      <div 
                        className="flex items-center space-x-2 cursor-pointer hover:text-blue-600 hover:underline transition-colors"
                        onClick={() => openDetailModal(cargo)}
                        title="Дэлгэрэнгүй харах"
                      >
                        <FaBarcode className="text-blue-500" />
                        <span className="font-medium">{cargo.cargo_code}</span>
                      </div>
                    </td>
                    
                    {/* 2. ИЛГЭЭГЧ */}
                    <td className="px-4 py-3">
                      <div className="text-sm">
                        <div className="font-medium">{cargo.sender_name}</div>
                        <div className="text-gray-500 text-xs">{cargo.sender_phone || '-'}</div>
                      </div>
                    </td>
                    
                    {/* 3. ХҮЛЭЭН АВАГЧ */}
                    <td className="px-4 py-3">
                      <div className="text-sm">
                        <div className="font-medium">{cargo.receiver_name}</div>
                        <div className="text-gray-500 text-xs">{cargo.receiver_phone || '-'}</div>
                      </div>
                    </td>
                    
                    {/* 4. ТОО/ШИРХЭГ */}
                    <td className="px-4 py-3 text-center">
                      <span className="text-xs bg-purple-100 text-purple-700 px-2 py-1 rounded">
                        {cargo.total_pieces}
                      </span>
                    </td>
                    
                    {/* 5. ТӨРӨЛ */}
                    <td className="px-4 py-3">
                      {cargo.cargo_type === 'weight' ? (
                        <span className="badge badge-warning flex items-center space-x-1">
                          <FaWeight className="w-3 h-3" />
                          <span>Жин</span>
                        </span>
                      ) : (
                        <span className="badge badge-info flex items-center space-x-1">
                          <FaCube className="w-3 h-3" />
                          <span>Эзлэхүүн</span>
                        </span>
                      )}
                    </td>
                    
                    {/* 6. ЖИН/ЭЗЛЭХҮҮН */}
                    <td className="px-4 py-3 text-sm">
                      {cargo.cargo_type === 'weight'
                        ? `${cargo.weight_kg} кг`
                        : `${(parseFloat(cargo.volume_cbm) || 0).toFixed(4)} м³`
                      }
                    </td>
                    
                    {/* 7. ҮНЭ - Байршлаар ялгах */}
                    {paymentLocations.map((loc) => (
                      <td key={loc.location_code} className="px-4 py-3 font-semibold text-green-600">
                        {cargo.location_code === loc.location_code 
                          ? `${parseFloat(cargo.price || 0).toLocaleString()}${getCurrencySymbol(cargo)}`
                          : <span className="text-gray-300">-</span>
                        }
                      </td>
                    ))}
                    {/* 8. ЧИНГЭЛЭГ - Нэрээр харуулах */}
                    <td className="px-4 py-3">
                      <span className="badge badge-primary">{cargo.container_name || cargo.container_code}</span>
                    </td>
                    
                    
                    {/* 9. ТӨЛӨВ */}
                    <td className="px-4 py-3">
                      {getStatusBadge(cargo.status)}
                    </td>
                    
                    {/* 10. ТАРААГДСАН ОГНОО */}
                    <td className="px-4 py-3 text-center">
                      {cargo.status === 'distributed' && cargo.distributed_date ? (
                        <span className="text-xs text-gray-700">
                          {new Date(cargo.distributed_date).toLocaleDateString('mn-MN', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </span>
                      ) : (
                        <span className="text-xs text-gray-400">-</span>
                      )}
                    </td>
                    
                    {/* 11. ҮЙЛДЭЛ */}
                    <td className="px-4 py-3">
                      <div className="flex space-x-2">
                        
                        {canView && (
                          <button
                            className="icon-button text-blue-600"
                            title="Дэлгэрэнгүй"
                            onClick={() => openDetailModal(cargo)}
                          >
                            <FaEye />
                          </button>
                        )}
                        
                        
                        {canEdit && cargo.status !== 'distributed' && (
                          <button
                            className="icon-button text-green-600"
                            title="Засах"
                            onClick={() => handleEditCargo(cargo)}
                          >
                            <FaPencilAlt />
                          </button>
                        )}
                        
                        
                        {canEdit && (
                          <button
                            className="icon-button text-orange-600"
                            title="Төлөв өөрчлөх"
                            onClick={() => openStatusModal(cargo)}
                          >
                            <FaSyncAlt />
                          </button>
                        )}

                        
                        {user?.role === 'system_admin' && cargo.status === 'distributed' && (
                          <button
                            className="icon-button text-yellow-600 hover:bg-yellow-50"
                            title="Тараалт буцаах (Admin only)"
                            onClick={() => {
                              setSelectedCargo(cargo);
                              setShowReverseModal(true);
                            }}
                          >
                            <FaUndo />
                          </button>
                        )}

                        
                        {canView && (
                          <div className="relative">
                            <button
                              className="icon-button text-purple-600"
                              title="Хэвлэх сонголт"
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePrintToggle(cargo.id);
                              }}
                            >
                              <FaPrint />
                            </button>
                            
                            {showPrintDropdown === cargo.id && (
                              <>
                                <div 
                                  className="fixed inset-0 z-40" 
                                  onClick={() => setShowPrintDropdown(null)}
                                ></div>
                                <div className="print-dropdown-menu">
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handlePrintReceipt1(cargo);
                                    }}
                                    className="print-dropdown-item"
                                  >
                                    <FaFileInvoice className="mr-2" />
                                    Баримт-1
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handlePrintReceipt2(cargo);
                                    }}
                                    className="print-dropdown-item"
                                  >
                                    <FaFileInvoice className="mr-2" />
                                    Баримт-2
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        )}

                        
                        {canDelete && cargo.status === 'registered' && (
                          <button
                            className="icon-button text-red-600"
                            title="Устгах"
                            onClick={() => handleDeleteCargo(cargo.id)}
                          >
                            <FaTrash />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
         {/* ✅ ХӨЛ ДҮН - Ажилтан сонгосон үед */}
        {selectedRegisteredBy !== 'all' && cargos.length > 0 && (
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-t border-blue-100 px-4 py-4">
            <div className="flex flex-wrap items-center gap-6">
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Нийт жин:</span>
                <span className="font-semibold text-gray-800">
                  {cargos.reduce((sum, c) => sum + parseFloat(c.weight_kg || 0), 0).toFixed(2)} кг
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Нийт эзлэхүүн:</span>
                <span className="font-semibold text-gray-800">
                  {cargos.reduce((sum, c) => sum + parseFloat(c.volume_cbm || 0), 0).toFixed(4)} м³
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Нийт дүн:</span>
                <span className="font-semibold text-green-600">
                  {cargos.reduce((sum, c) => sum + parseFloat(c.price || 0), 0).toLocaleString()}₩
                </span>
              </div>
              <div className="h-6 w-px bg-blue-200"></div>
              {paymentLocations.map((loc) => (
                <div key={loc.location_code} className="flex items-center gap-2">
                  <span className="text-sm text-gray-600">{loc.location_name}:</span>
                  <span className="font-semibold text-blue-600">
                    {cargos
                      .filter(c => c.location_code === loc.location_code)
                      .reduce((sum, c) => sum + parseFloat(c.price || 0), 0)
                      .toLocaleString()}₩
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="table-footer flex justify-between items-center px-4 py-3 border-t">
          <span className="text-sm text-gray-600">
            Нийт {pagination.totalItems || cargos.length} ачаа
          </span>
          <div className="flex space-x-2">
            <button
              onClick={() => handlePageChange(pagination.currentPage - 1)}
              disabled={pagination.currentPage === 1}
              className="pagination-btn"
            >
              Өмнөх
            </button>
            <span className="text-sm text-gray-600 px-3 py-1">
              {pagination.currentPage} / {pagination.totalPages}
            </span>
            <button
              onClick={() => handlePageChange(pagination.currentPage + 1)}
              disabled={pagination.currentPage === pagination.totalPages}
              className="pagination-btn"
            >
              Дараах
            </button>
          </div>
        </div>
      </div>

      {/* ADD MODAL */}
      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal-content max-w-4xl">
            <div className="modal-header">
              <h3 className="text-xl font-bold text-gray-800 flex items-center">
                <FaPlus className="w-5 h-5 mr-3 text-blue-600" />
                Ачаа бүртгэх
              </h3>
              <button
                onClick={() => {
                  setShowAddModal(false);
                  resetForm();
                }}
                className="icon-button text-gray-400 hover:text-gray-600"
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>
            
            <div className="modal-body max-h-[70vh] overflow-y-auto">
              <form onSubmit={handleAddCargo}>
                <div className="space-y-6">
                  {/* Container Selection */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      <FaTruck className="inline w-4 h-4 mr-2 text-blue-600" />
                      Чингэлэг <span className="text-red-500">*</span>
                    </label>
                    <select
                      className={`custom-input ${formErrors.container_id ? 'border-red-300 bg-red-50' : ''}`}
                      value={cargoForm.container_id}
                      onChange={(e) => {
                        setCargoForm({...cargoForm, container_id: e.target.value});
                        setFormErrors({...formErrors, container_id: ''});
                      }}
                    >
                      <option value="">Чингэлэг сонгох...</option>
                      {containers.map((container) => (
                      <option key={container.id} value={container.id}>
                        {container.name || container.container_code}
                      </option>
                    ))}
                    </select>
                    {formErrors.container_id && (
                      <p className="text-red-500 text-xs mt-1 flex items-center">
                        <FaExclamationTriangle className="w-3 h-3 mr-1" />
                        {formErrors.container_id}
                      </p>
                    )}
                  </div>

                  {/* Cargo Name */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      <FaTag className="inline w-4 h-4 mr-2 text-purple-600" />
                      Ачааны нэр
                    </label>
                    <input
                      type="text"
                      className="custom-input"
                      placeholder="Ачааны нэр оруулах..."
                      value={cargoForm.cargo_name}
                      onChange={(e) => setCargoForm({...cargoForm, cargo_name: e.target.value})}
                    />
                  </div>

                  {/* Sender Info */}
                  <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
                    <h4 className="font-semibold text-purple-800 mb-4 flex items-center">
                      <FaUsers className="mr-2" />
                      Илгээгчийн мэдээлэл
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="form-group">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Нэр <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          className={`custom-input ${formErrors.sender_name ? 'border-red-300 bg-red-50' : ''}`}
                          placeholder="Илгээгчийн нэр..."
                          value={cargoForm.sender_name}
                          onChange={(e) => {
                            setCargoForm({...cargoForm, sender_name: e.target.value});
                            setFormErrors({...formErrors, sender_name: ''});
                          }}
                        />
                        {formErrors.sender_name && (
                          <p className="text-red-500 text-xs mt-1">{formErrors.sender_name}</p>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Утас</label>
                        <input
                          type="text"
                          className="custom-input"
                          placeholder="Утасны дугаар..."
                          value={cargoForm.sender_phone}
                          onChange={(e) => setCargoForm({...cargoForm, sender_phone: e.target.value})}
                        />
                      </div>
                      <div className="form-group md:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Хаяг</label>
                        <input
                          type="text"
                          className="custom-input"
                          placeholder="Хаяг..."
                          value={cargoForm.sender_address}
                          onChange={(e) => setCargoForm({...cargoForm, sender_address: e.target.value})}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Receiver Info */}
                  <div className="bg-orange-50 p-4 rounded-lg border border-orange-200">
                    <h4 className="font-semibold text-orange-800 mb-4 flex items-center">
                      <FaUsers className="mr-2" />
                      Хүлээн авагчийн мэдээлэл
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="form-group">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Нэр <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          className={`custom-input ${formErrors.receiver_name ? 'border-red-300 bg-red-50' : ''}`}
                          placeholder="Хүлээн авагчийн нэр..."
                          value={cargoForm.receiver_name}
                          onChange={(e) => {
                            setCargoForm({...cargoForm, receiver_name: e.target.value});
                            setFormErrors({...formErrors, receiver_name: ''});
                          }}
                        />
                        {formErrors.receiver_name && (
                          <p className="text-red-500 text-xs mt-1">{formErrors.receiver_name}</p>
                        )}
                      </div>
                      <div className="form-group">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Утас</label>
                        <input
                          type="text"
                          className="custom-input"
                          placeholder="Утасны дугаар..."
                          value={cargoForm.receiver_phone}
                          onChange={(e) => setCargoForm({...cargoForm, receiver_phone: e.target.value})}
                        />
                      </div>
                      <div className="form-group md:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Хаяг</label>
                        <input
                          type="text"
                          className="custom-input"
                          placeholder="Хаяг..."
                          value={cargoForm.receiver_address}
                          onChange={(e) => setCargoForm({...cargoForm, receiver_address: e.target.value})}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Cargo Type Selection */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-3">
                      <FaBox className="inline w-4 h-4 mr-2 text-green-600" />
                      Ачааны төрөл <span className="text-red-500">*</span>
                    </label>
                    <div className="flex gap-4">
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="cargo_type"
                          value="weight"
                          checked={cargoForm.cargo_type === 'weight'}
                          onChange={(e) => setCargoForm({...cargoForm, cargo_type: e.target.value})}
                          className="w-4 h-4"
                        />
                        <span className="flex items-center gap-2">
                          <FaWeight className="text-yellow-600" />
                          <span className="font-medium">Жин</span>
                        </span>
                      </label>
                      <label className="flex items-center space-x-2 cursor-pointer">
                        <input
                          type="radio"
                          name="cargo_type"
                          value="volume"
                          checked={cargoForm.cargo_type === 'volume'}
                          onChange={(e) => setCargoForm({...cargoForm, cargo_type: e.target.value})}
                          className="w-4 h-4"
                        />
                        <span className="flex items-center gap-2">
                          <FaCube className="text-blue-600" />
                          <span className="font-medium">Эзлэхүүн</span>
                        </span>
                      </label>
                    </div>
                  </div>

                  {/* Weight or Volume Input */}
                  {!cargoForm.is_manual_price && (
                    <>
                      {cargoForm.cargo_type === 'weight' ? (
                        <div className="form-group">
                          <label className="block text-sm font-semibold text-gray-700 mb-2">
                            <FaWeight className="inline w-4 h-4 mr-2 text-yellow-600" />
                            Жин (кг) <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="number"
                            step="0.01"
                            className={`custom-input ${formErrors.weight_kg ? 'border-red-300 bg-red-50' : ''}`}
                            placeholder="Жинг оруулах..."
                            value={cargoForm.weight_kg}
                            onChange={(e) => {
                              setCargoForm({...cargoForm, weight_kg: e.target.value});
                              setFormErrors({...formErrors, weight_kg: ''});
                            }}
                          />
                          {formErrors.weight_kg && (
                            <p className="text-red-500 text-xs mt-1">{formErrors.weight_kg}</p>
                          )}
                        </div>
                      ) : (
                        <div className="grid grid-cols-3 gap-4">
                          <div className="form-group">
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                              Урт (см) <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              className={`custom-input ${formErrors.length_cm ? 'border-red-300 bg-red-50' : ''}`}
                              placeholder="Урт..."
                              value={cargoForm.length_cm}
                              onChange={(e) => {
                                setCargoForm({...cargoForm, length_cm: e.target.value});
                                setFormErrors({...formErrors, length_cm: ''});
                              }}
                            />
                            {formErrors.length_cm && (
                              <p className="text-red-500 text-xs mt-1">{formErrors.length_cm}</p>
                            )}
                          </div>
                          <div className="form-group">
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                              Өргөн (см) <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              className={`custom-input ${formErrors.width_cm ? 'border-red-300 bg-red-50' : ''}`}
                              placeholder="Өргөн..."
                              value={cargoForm.width_cm}
                              onChange={(e) => {
                                setCargoForm({...cargoForm, width_cm: e.target.value});
                                setFormErrors({...formErrors, width_cm: ''});
                              }}
                            />
                            {formErrors.width_cm && (
                              <p className="text-red-500 text-xs mt-1">{formErrors.width_cm}</p>
                            )}
                          </div>
                          <div className="form-group">
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                              Өндөр (см) <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              className={`custom-input ${formErrors.height_cm ? 'border-red-300 bg-red-50' : ''}`}
                              placeholder="Өндөр..."
                              value={cargoForm.height_cm}
                              onChange={(e) => {
                                setCargoForm({...cargoForm, height_cm: e.target.value});
                                setFormErrors({...formErrors, height_cm: ''});
                              }}
                            />
                            {formErrors.height_cm && (
                              <p className="text-red-500 text-xs mt-1">{formErrors.height_cm}</p>
                            )}
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  {/* Total Pieces */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      <FaBox className="inline w-4 h-4 mr-2 text-purple-600" />
                      Тоо/Ширхэг <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      min="1"
                      className={`custom-input ${formErrors.total_pieces ? 'border-red-300 bg-red-50' : ''}`}
                      placeholder="Ширхэгийн тоо..."
                      value={cargoForm.total_pieces}
                      onChange={(e) => {
                        setCargoForm({...cargoForm, total_pieces: e.target.value});
                        setFormErrors({...formErrors, total_pieces: ''});
                      }}
                    />
                    {formErrors.total_pieces && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.total_pieces}</p>
                    )}
                  </div>

                  {/* Price - Calculated or Manual */}
                  <div className="bg-gradient-to-br from-green-50 to-emerald-100 p-5 rounded-xl border border-green-200 shadow-md">
                    <div className="flex items-center justify-between mb-3">
                      <h4 className="font-semibold text-green-800 flex items-center gap-2">
                        <FaMoneyBillWave className="text-green-600" />
                        Үнийн мэдээлэл
                      </h4>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={cargoForm.is_manual_price}
                          onChange={(e) => setCargoForm({
                            ...cargoForm, 
                            is_manual_price: e.target.checked,
                            manual_price: e.target.checked ? cargoForm.manual_price : ''
                          })}
                          className="w-4 h-4 text-blue-600 rounded"
                        />
                        <span className="text-sm font-medium text-gray-700">Гараас үнэ оруулах</span>
                      </label>
                    </div>

                    {cargoForm.is_manual_price ? (
                      <div className="form-group mb-0">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Үнэ оруулах <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="number"
                          step="0.01"
                          className={`custom-input ${formErrors.manual_price ? 'border-red-300 bg-red-50' : ''}`}
                          placeholder="Үнэ оруулах..."
                          value={cargoForm.manual_price}
                          onChange={(e) => {
                            setCargoForm({...cargoForm, manual_price: e.target.value});
                            setFormErrors({...formErrors, manual_price: ''});
                          }}
                          required={cargoForm.is_manual_price}
                        />
                        {formErrors.manual_price && (
                          <p className="text-red-500 text-xs mt-1">{formErrors.manual_price}</p>
                        )}
                      </div>
                    ) : (
                      calculatedPrice && (
                        <div>
                          <div className="text-3xl font-bold text-green-600">
                            {parseFloat(calculatedPrice.totalPrice).toLocaleString()} {calculatedPrice.currency}
                          </div>
                          <p className="text-sm text-green-700 mt-1">
                            {calculatedPrice.pieces} ширхэг
                          </p>
                        </div>
                      )
                    )}
                  </div>

                  {/* Storage Fee & Payment Location */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="form-group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <FaWarehouse className="inline w-4 h-4 mr-2 text-orange-600" />
                        Хадгалалтын үнэ <span className="text-red-500">*</span>
                      </label>
                      <select
                        className="custom-input"
                        value={cargoForm.storage_fee_id}
                        required
                        onChange={(e) => setCargoForm({...cargoForm, storage_fee_id: e.target.value})}
                      >
                          <option value="">Сонгоно уу *</option>
                        {storageFees.map((fee) => (
                          <option key={fee.id} value={fee.id}>
                            {fee.fee_name} - {Number(fee.price_per_day).toLocaleString()}{getCurrencyCode(fee.currency_id)}/{fee.unit_type === 'per_piece' ? 'ширхэг' : fee.unit_type === 'per_kg' ? 'кг' : 'м³'}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <FaMapMarkerAlt className="inline w-4 h-4 mr-2 text-purple-600" />
                        Төлбөр төлөх байршил <span className="text-red-500">*</span>
                      </label>
                      <select
                        className="custom-input"
                        value={cargoForm.payment_location_id}
                        onChange={(e) => setCargoForm({...cargoForm, payment_location_id: e.target.value})}
                        required
                      >
                        <option value="">Сонгох...</option>
                        {paymentLocations.map((loc) => (
                          <option key={loc.id} value={loc.id}>
                            {loc.location_name} ({getCurrencyCode(loc.currency_id)})
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Images Upload */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      <FaImage className="inline w-4 h-4 mr-2 text-blue-600" />
                      Зураг оруулах
                    </label>
                    <div className="flex items-center gap-4">
                      <label className="custom-button flex items-center cursor-pointer">
                        <FaUpload className="mr-2" />
                        {uploadingImage ? 'Хуулж байна...' : 'Зураг сонгох'}
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={handleImageUpload}
                          disabled={uploadingImage}
                        />
                      </label>
                    </div>
                    {cargoForm.images.length > 0 && (
                      <div className="mt-4 grid grid-cols-4 gap-2">
                        {cargoForm.images.map((img, idx) => (
                          <div key={idx} className="relative group">
                            <img
                              src={`${window.location.origin}${img}`}
                              alt={`Preview ${idx + 1}`}
                              className="w-full h-24 object-cover rounded border"
                            />
                            <button
                              type="button"
                              onClick={() => removeImage(idx, img)}
                              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                              <FaTimes className="w-3 h-3" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Description */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      <FaInfoCircle className="inline w-4 h-4 mr-2 text-gray-600" />
                      Нэмэлт тайлбар
                    </label>
                    <textarea
                      className="custom-input"
                      rows="3"
                      placeholder="Нэмэлт тайлбар..."
                      value={cargoForm.description}
                      onChange={(e) => setCargoForm({...cargoForm, description: e.target.value})}
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    onClick={() => {
                      setShowAddModal(false);
                      resetForm();
                    }}
                    className="custom-button-secondary"
                    disabled={loading}
                  >
                    Цуцлах
                  </button>
                  <button
                    type="submit"
                    className="custom-button-success"
                    disabled={loading}
                  >
                    {loading ? (
                      <div className="flex items-center justify-center">
                        <div className="loading-spinner mr-2"></div>
                        Бүртгэж байна...
                      </div>
                    ) : (
                      <div className="flex items-center">
                        <FaSave className="w-4 h-4 mr-2" />
                        Бүртгэх
                      </div>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* //frontend/src/admin/CargoManagement.js */}
      {/* 2-р хэсэг */}

      {/* STATUS CHANGE MODAL */}
      {showStatusModal && selectedCargo && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="text-xl font-bold text-gray-800 flex items-center">
                <FaSyncAlt className="w-5 h-5 mr-3 text-orange-600" />
                Төлөв өөрчлөх
              </h3>
              <button
                onClick={() => {
                  setShowStatusModal(false);
                  setNewSelectedStatus('');
                  setPaymentData({ method: 'cash', receiver_phone: '', note: '' });  // 🆕 note нэмсэн
                }}
                className="icon-button text-gray-400 hover:text-gray-600"
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>

            <div className="modal-body">
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <p className="text-sm text-blue-800">
                    <strong>Одоогийн төлөв:</strong> {getStatusBadge(selectedCargo.status)}
                  </p>
                </div>

                <div className="form-group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Шинэ төлөв сонгох
                  </label>
                  <select
                    className="custom-input"
                    value={newSelectedStatus}
                    onChange={(e) => setNewSelectedStatus(e.target.value)}
                    required
                  >
                    {cargoStatuses.map((status) => (
                      <option key={status.code} value={status.code}>
                        {status.name}
                      </option>
                    ))}
                  </select>
                </div>

            

                {/* DISTRIBUTED ТӨЛӨВТ ШИЛЖИХ ҮЕД */}
                {newSelectedStatus === 'distributed' && selectedCargo.status !== 'distributed' && (
                  <>
                    <div className="bg-green-50 border-l-4 border-green-400 p-4">
                      <div className="flex items-start">
                        <FaCheckCircle className="text-green-500 mr-3 mt-1" />
                        <div className="text-sm text-green-700">
                          <p className="font-semibold mb-1">✅ Төлбөр бүртгэгдэнэ</p>
                          <p>Ачааг "Тараагдсан" төлөвт шилжүүлэх үед төлбөрийн мэдээлэл автоматаар бүртгэгдэнэ.</p>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <FaMoneyBillWave className="inline mr-2 text-green-600" />
                        Төлбөрийн хэлбэр <span className="text-red-500">*</span>
                      </label>
                      <select
                        className="custom-input"
                        value={paymentData.method}
                        onChange={(e) => setPaymentData({...paymentData, method: e.target.value})}
                        required
                      >
                        <option value="cash">Бэлэн мөнгө</option>
                        <option value="transfer">Шилжүүлэг</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <FaPhone className="inline mr-2 text-blue-600" />
                        Хүлээн авагчийн утас (баталгаажуулах)
                      </label>
                      <input
                        type="tel"
                        className="custom-input"
                        placeholder={selectedCargo.receiver_phone || "Утасны дугаар оруулах..."}
                        value={paymentData.receiver_phone}
                        onChange={(e) => setPaymentData({...paymentData, receiver_phone: e.target.value})}
                      />
                      <p className="text-xs text-gray-500 mt-1">
                        Анхны утас: {selectedCargo.receiver_phone || 'Бүртгээгүй'}
                      </p>
                    </div>
                    {/* 🆕 ТӨЛБӨРИЙН ТАЙЛБАР */}
                      <div className="form-group">
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          <FaInfoCircle className="inline mr-2 text-gray-600" />
                          Тайлбар
                        </label>
                        <textarea
                          className="custom-input"
                          rows="3"
                          placeholder="Төлбөрийн тайлбар оруулах..."
                          value={paymentData.note}
                          onChange={(e) => setPaymentData({...paymentData, note: e.target.value})}
                        />
                        <p className="text-xs text-gray-500 mt-1 flex items-center gap-1">
                          <FaHistory className="text-gray-400" />
                          Энэ тайлбар төлбөрийн бүртгэл болон ачааны мэдээлэлд хадгалагдана
                        </p>
                      </div>

                    {/* ТӨЛБӨРИЙН ДЭЛГЭРЭНГҮЙ */}
                    <div className="bg-gray-50 p-4 rounded-lg border">
                      <h4 className="font-semibold text-gray-800 mb-3">Төлбөрийн дэлгэрэнгүй:</h4>
                      <div className="space-y-2 text-sm">
                        <div className="flex justify-between">
                          <span className="text-gray-600">Ачааны үнэ:</span>
                          <span className="font-bold text-green-600">
                            {formatCurrency(
                              selectedCargo.is_manual_price ? selectedCargo.manual_price : selectedCargo.price,
                              selectedCargo.price_currency_code || selectedCargo.currency_code
                            )}
                          </span>
                        </div>
                        {selectedCargo.storage_fee_amount && selectedCargo.storage_fee_amount > 0 && (
                          <div className="flex justify-between">
                            <span className="text-gray-600">Хадгалалтын хөлс ({selectedCargo.storage_days || 0}ө):</span>
                            <span className="font-bold text-orange-600">
                              {formatCurrency(selectedCargo.storage_fee_amount, selectedCargo.price_currency_code || selectedCargo.currency_code)}
                            </span>
                          </div>
                        )}
                        <div className="flex justify-between pt-2 border-t">
                          <span className="font-semibold text-gray-800">НИЙТ ДҮН:</span>
                          <span className="text-xl font-bold text-blue-600">
                            {(() => {
                              const cargoPrice = parseFloat(selectedCargo.is_manual_price ? selectedCargo.manual_price || '0' : selectedCargo.price || '0') || 0;
                              const storageFee = parseFloat(selectedCargo.storage_fee_amount || '0') || 0;
                              const total = cargoPrice + storageFee;
                              return formatCurrency(total.toFixed(2), selectedCargo.price_currency_code || selectedCargo.currency_code);
                            })()}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                onClick={() => {
                  setShowStatusModal(false);
                  setNewSelectedStatus('');
                  setPaymentData({ method: 'cash', receiver_phone: '', note: '' });  // 🆕 note нэмсэн
                }}
                className="custom-button-secondary"
              >
                Цуцлах
              </button>
              <button
                type="button"
                onClick={handleStatusChange}
                className="custom-button-success"
                disabled={newSelectedStatus === 'distributed' && !paymentData.method}
              >
                <div className="flex items-center">
                  <FaSyncAlt className="w-4 h-4 mr-2" />
                  {newSelectedStatus === 'distributed' ? 'Төлбөр бүртгэх' : 'Шинэчлэх'}
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* REVERSE DISTRIBUTION MODAL - SYSTEM ADMIN */}
      {/* REVERSE DISTRIBUTION MODAL - SYSTEM ADMIN ONLY */}
      {/* REVERSE DISTRIBUTION MODAL - SYSTEM ADMIN ONLY */}
      {showReverseModal && selectedCargo && (
        <div className="modal-overlay">
          <div className="modal-content max-w-lg">
            {/* HEADER - CSS өнгө */}
            <div className="reverse-modal-header">
              <h3 className="text-xl font-bold text-white flex items-center gap-3">
                <FaUndo className="w-7 h-7 reverse-icon-pulse" />
                Тараалт буцаах
              </h3>
              <button
                onClick={() => {
                  setShowReverseModal(false);
                  setReverseReason('');
                }}
                className="text-white hover:text-gray-200 transition-colors"
              >
                <FaTimes className="w-6 h-6" />
              </button>
            </div>

            {/* BODY */}
            <div className="modal-body">
              <div className="space-y-4">
                {/* Анхааруулга */}
                <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
                  <div className="flex items-start">
                    <FaExclamationTriangle className="text-red-500 text-xl mr-3 mt-0.5 flex-shrink-0" />
                    <div>
                      <h4 className="text-red-800 font-bold mb-2">⚠️ Анхааруулга</h4>
                      <ul className="text-sm text-red-700 space-y-1 list-disc list-inside">
                        <li>Төлбөрийн бүртгэл <strong>устгагдана</strong></li>
                        <li>Ачаа "Тараагдаагүй" төлөвт <strong>буцна</strong></li>
                        <li>Дахин тараах боломжтой болно</li>
                        <li>Энэ үйлдлийг <strong>буцаах боломжгүй</strong></li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Ачааны мэдээлэл */}
                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <h5 className="font-semibold text-blue-800 mb-2 flex items-center gap-2">
                    <FaBox className="text-blue-600" />
                    Ачааны мэдээлэл
                  </h5>
                  <div className="text-sm space-y-1 text-blue-900">
                    <p><strong>Багц код:</strong> {selectedCargo.batch_number}</p>
                    <p><strong>Хүлээн авагч:</strong> {selectedCargo.receiver_name}</p>
                    <p><strong>Үнэ:</strong> {formatCurrency(
                      selectedCargo.is_manual_price ? selectedCargo.manual_price : selectedCargo.price,
                      selectedCargo.price_currency_code || selectedCargo.currency_code
                    )}</p>
                  </div>
                </div>

                {/* Шалтгаан оруулах */}
                <div className="form-group">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    <FaInfoCircle className="inline mr-2 text-gray-600" />
                    Буцаах шалтгаан <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    className="custom-input"
                    rows="4"
                    placeholder="Яагаад тараалт буцааж байгаа шалтгаанаа тодорхой бичнэ үү..."
                    value={reverseReason}
                    onChange={(e) => setReverseReason(e.target.value)}
                    required
                  />
                  <p className="text-xs text-gray-500 mt-1 flex items-center gap-1">
                    <FaHistory className="text-gray-400" />
                    Энэ мэдээлэл түүхэнд хадгалагдана
                  </p>
                </div>
              </div>
            </div>

            {/* FOOTER - CSS өнгө */}
            <div className="modal-footer bg-gray-50 border-t">
              <button
                type="button"
                onClick={() => {
                  setShowReverseModal(false);
                  setReverseReason('');
                }}
                className="px-6 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 hover:border-gray-400 transition-all flex items-center gap-2 shadow-sm"
                disabled={reversingCargo}
              >
                <FaTimes className="w-5 h-5" />
                <span>Хаах</span>
              </button>
              
              <button
                type="button"
                onClick={handleReverseDistribution}
                className="reverse-action-button"
                disabled={reversingCargo || !reverseReason.trim()}
              >
                {reversingCargo ? (
                  <>
                    <div className="loading-spinner w-6 h-6 border-white"></div>
                    <span>Буцааж байна...</span>
                  </>
                ) : (
                  <>
                    <FaUndo className="w-6 h-6" />
                    <span>БУЦААХ</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ✅ ЗАСАХ MODAL */}
        {showEditModal && editingCargo && (
          <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
            <div className="modal-content max-w-4xl" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3 className="text-xl font-bold flex items-center">
                  <FaPencilAlt className="mr-2 text-green-600" />
                  Ачаа засах
                </h3>
                <button onClick={() => setShowEditModal(false)}>
                  <FaTimes />
                </button>
              </div>

              <div className="modal-body">
                <CargoEditForm 
                cargo={editingCargo}
                onSave={handleSaveEdit}
                onCancel={() => setShowEditModal(false)}
                canEditPrice={canEditPrice}
                containers={containers}
                paymentLocations={paymentLocations}
              />
              </div>
            </div>
          </div>
        )}

      {/* DETAIL MODAL */}
      {showDetailModal && selectedCargo && (
        <div className="modal-overlay">
          <div className={`cargo-detail-modal ${isPrintMode ? 'print-mode' : ''}`}>
            <div className="modal-header print-header bg-gradient-to-r from-blue-400 to-blue-500 rounded-t-xl shadow-lg">
              <h3 className="text-xl font-bold flex items-center text-gray-800">
                <FaBox className="w-6 h-6 mr-3 text-gray-800" />
                Ачааны дэлгэрэнгүй
              </h3>
              <button
                onClick={() => {
                  setShowDetailModal(false);
                  setSelectedCargo(null);
                }}
                className="no-print text-gray-800 hover:text-gray-600 transition-colors"
              >
                <FaTimes className="w-6 h-6" />
              </button>
            </div>

            <div className="cargo-detail-body p-6 bg-gradient-to-b from-gray-50 to-white">
              {/* HEADER */}
              <div className="bg-gradient-to-r from-indigo-50 to-blue-50 p-6 rounded-xl mb-6 border border-indigo-200 shadow-md">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                  <div className="flex-1">
                    <h4 className="text-2xl font-bold text-gray-800 mb-3">
                      {selectedCargo.cargo_name || 'Ачааны мэдээлэл'}
                    </h4>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div className="flex items-center gap-2 text-sm">
                        <span className="text-gray-600 font-medium">Багц код:</span>
                        <span className="font-semibold text-gray-900 bg-white px-3 py-1 rounded-lg shadow-sm">
                          {selectedCargo.batch_number || '-'}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 text-sm">
                        <span className="text-gray-600 font-medium">Тоо/Ширхэг:</span>
                        <span className="font-semibold text-gray-900 bg-white px-3 py-1 rounded-lg shadow-sm">
                          {selectedCargo.total_pieces || '-'}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="text-left md:text-right flex flex-col items-end">
                    {getStatusBadge(selectedCargo.status)}
                    <div className="text-3xl font-bold text-green-600 mt-2 flex items-center">
                      {parseFloat(selectedCargo.price || 0).toLocaleString()}
                      <span className="text-sm ml-1">{getCurrencySymbol(selectedCargo)}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* STORAGE FEE */}
              {selectedCargo.storage_fee_amount > 0 && (
                <div className="mb-6 p-4 bg-gradient-to-r from-yellow-50 to-orange-50 border-l-4 border-yellow-400 rounded-lg shadow-md">
                  <h5 className="text-lg font-semibold text-yellow-800 mb-2 flex items-center">
                    <FaExclamationTriangle className="mr-2 text-yellow-500" />
                    Хадгалалтын хөлс нэмэгдсэн
                  </h5>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
                    <div className="bg-white p-3 rounded-lg shadow-sm">
                      <p className="text-yellow-700 font-medium">Хадгалагдсан өдрүүд</p>
                      <p className="text-2xl font-bold text-yellow-800">{selectedCargo.storage_days} өдөр</p>
                    </div>
                    <div className="bg-white p-3 rounded-lg shadow-sm">
                      <p className="text-yellow-700 font-medium">Нэмэгдэх дүн</p>
                      <p className="text-2xl font-bold text-yellow-800">
                        {parseFloat(selectedCargo.storage_fee_amount || 0).toLocaleString()}
                        <span className="text-sm ml-1">{getCurrencySymbol(selectedCargo)}</span>
                      </p>
                    </div>
                    <div className="bg-white p-3 rounded-lg shadow-sm">
                      <p className="text-yellow-700 font-medium">Нийт дүн (үндсэн + хадгалалт)</p>
                      <p className="text-2xl font-bold text-yellow-800">
                        {parseFloat(selectedCargo.total_with_storage || 0).toLocaleString()}
                        <span className="text-sm ml-1">{getCurrencySymbol(selectedCargo)}</span>
                      </p>
                    </div>
                  </div>
                  <p className="text-xs text-yellow-600 mt-2 italic">
                    Чингэлэг тараасны 7 хоногийн дараа хоног тутамд тооцогдоно
                  </p>
                </div>
              )}

              {/* IMAGES */}
              {selectedCargo.images && selectedCargo.images.length > 0 && (
                <div className="mb-6">
                  <h5 className="text-lg font-semibold text-gray-700 mb-3 flex items-center gap-2">
                    <FaImage className="text-purple-500" />
                    Ачааны зураг ({selectedCargo.images.length})
                  </h5>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                    {selectedCargo.images.map((img, idx) => (
                      <div key={idx} className="group relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300">
                        <img
                          src={`${window.location.origin}${img}`}
                          alt={`Cargo ${idx + 1}`}
                          className="w-full h-32 object-cover transition-transform duration-300 group-hover:scale-110 cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            openImageModal(selectedCargo.images, idx);
                          }}
                          onError={(e) => { e.target.src = 'https://via.placeholder.com/200' }}
                        />
                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
                          <FaSearchPlus className="text-white text-2xl" />
                        </div>
                        <div className="absolute bottom-2 right-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded">
                          {idx + 1}/{selectedCargo.images.length}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* ИЛГЭЭГЧ БА ХҮЛЭЭН АВАГЧ */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-xl border border-purple-200 shadow-md">
                  <h5 className="text-lg font-semibold text-purple-800 mb-4 flex items-center gap-2">
                    <FaUsers className="text-purple-500" />
                    Илгээгч
                  </h5>
                  <div className="space-y-4 text-sm">
                    <div className="flex justify-between items-center py-2 border-b border-purple-100">
                      <span className="text-purple-600 font-medium">Нэр:</span>
                      <span className="font-bold text-gray-900">{selectedCargo.sender_name}</span>
                    </div>
                    <div className="flex justify-between items-center py-2 border-b border-purple-100">
                      <span className="text-purple-600 font-medium">Утас:</span>
                      <span className="font-bold text-gray-900">{selectedCargo.sender_phone || '-'}</span>
                    </div>
                    <div className="flex justify-between items-start py-2">
                      <span className="text-purple-600 font-medium">Хаяг:</span>
                      <span className="font-bold text-gray-900 max-w-xs break-words text-right">
                        {selectedCargo.sender_address || '-'}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-6 rounded-xl border border-orange-200 shadow-md">
                  <h5 className="text-lg font-semibold text-orange-800 mb-4 flex items-center gap-2">
                    <FaUsers className="text-orange-500" />
                    Хүлээн авагч
                  </h5>
                  <div className="space-y-4 text-sm">
                    <div className="flex justify-between items-center py-2 border-b border-orange-100">
                      <span className="text-orange-600 font-medium">Нэр:</span>
                      <span className="font-bold text-gray-900">{selectedCargo.receiver_name}</span>
                    </div>
                    <div className="flex justify-between items-center py-2 border-b border-orange-100">
                      <span className="text-orange-600 font-medium">Утас:</span>
                      <span className="font-bold text-gray-900">{selectedCargo.receiver_phone || '-'}</span>
                    </div>
                    <div className="flex justify-between items-start py-2">
                      <span className="text-orange-600 font-medium">Хаяг:</span>
                      <span className="font-bold text-gray-900 max-w-xs break-words text-right">
                        {selectedCargo.receiver_address || '-'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* ТЕХНИК МЭДЭЭЛЭЛ */}
              <div className="bg-gradient-to-br from-green-50 to-emerald-100 p-6 rounded-xl border border-green-200 shadow-md mb-6">
                <h5 className="text-lg font-semibold text-green-800 mb-4 flex items-center gap-2">
                  <FaBox className="text-green-500" />
                  Техник мэдээлэл
                </h5>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                  <div className="bg-white p-4 rounded-lg text-center border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                    <p className="text-gray-600 text-xs mb-2">Төрөл</p>
                    <p className="font-bold text-lg">
                      {selectedCargo.cargo_type === 'weight' ? (
                        <span className="flex items-center justify-center gap-1 text-yellow-600">
                          <FaWeight className="w-4 h-4" />
                          <span>Жин</span>
                        </span>
                      ) : (
                        <span className="flex items-center justify-center gap-1 text-blue-600">
                          <FaCube className="w-4 h-4" />
                          <span>Эзлэхүүн</span>
                        </span>
                      )}
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded-lg text-center border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                    <p className="text-gray-600 text-xs mb-2">Жин</p>
                    <p className="font-bold text-lg text-gray-900">{selectedCargo.weight_kg || '-'} кг</p>
                  </div>
                  <div className="bg-white p-4 rounded-lg text-center border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                    <p className="text-gray-600 text-xs mb-2">Эзлэхүүн</p>
                    <p className="font-bold text-lg text-gray-900">
                      {selectedCargo.volume_cbm
                        ? `${parseFloat(selectedCargo.volume_cbm).toFixed(4)} м³`
                        : '-'
                      }
                    </p>
                  </div>                  
                  <div className="bg-white p-4 rounded-lg text-center border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                    <p className="text-gray-600 text-xs mb-2">Үнэ</p>
                    <p className="font-bold text-lg text-green-600 flex items-center justify-center">
                      {parseFloat(selectedCargo.price || 0).toLocaleString()}
                      <span className="text-sm ml-1">{getCurrencySymbol(selectedCargo)}</span>
                    </p>
                  </div>
                </div>
              </div>

              {/* ЧИНГЭЛЭГ, ОГНОО, НЭМЭЛТ ТӨЛБӨР */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-5 rounded-xl border border-blue-200 shadow-md">
                  <h5 className="text-md font-semibold text-blue-800 mb-4 flex items-center gap-2">
                    <FaTruck className="text-blue-500" />
                    Ачааны байршил
                  </h5>
                  <div className="space-y-3 text-sm">
                     <p><strong>Чингэлэг:</strong> <span className="font-medium">{selectedCargo.container_name || selectedCargo.container_code}</span></p>
                    <p><strong>Байршил:</strong> <span className="font-medium">{selectedCargo.container_road_name || '-'}</span></p>
                    <p><strong>Төлөв:</strong> <span className="font-medium">{selectedCargo.container_status || '-'}</span></p>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-yellow-50 to-amber-100 p-5 rounded-xl border border-yellow-200 shadow-md">
                  <h5 className="text-md font-semibold text-yellow-800 mb-4 flex items-center gap-2">
                    <FaCalendarAlt className="text-yellow-500" />
                    Огноо
                  </h5>
                  <div className="text-sm space-y-3">
                    <div>
                      <p className="text-yellow-700 font-semibold mb-1">Бүртгэсэн:</p>
                      <p className="font-medium text-gray-800">
                        {formatDate(selectedCargo.registered_date)}
                      </p>
                    </div>
                    {selectedCargo.container_distribution_date && (
                      <div className="pt-2 border-t border-yellow-200">
                        <p className="text-yellow-700 font-semibold mb-1">Тараагдах огноо:</p>
                        <p className="font-medium text-gray-800">
                          {formatDate(selectedCargo.container_distribution_date)}
                        </p>
                      </div>
                    )}
                    {!selectedCargo.container_distribution_date && selectedCargo.container_arrival_date && (
                      <div className="pt-2 border-t border-yellow-200">
                        <p className="text-yellow-700 font-semibold mb-1">Ирсэн огноо:</p>
                        <p className="font-medium text-gray-800">
                          {formatDate(selectedCargo.container_arrival_date)}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                <div className="bg-gradient-to-br from-pink-50 to-rose-100 p-5 rounded-xl border border-pink-200 shadow-md">
                  <h5 className="text-md font-semibold text-pink-800 mb-4 flex items-center gap-2">
                    <FaMoneyBillWave className="text-pink-500" />
                    Нэмэлт төлбөр
                  </h5>
                  <div className="text-sm space-y-2">
                    <p><strong>Хадгалах үнэ:</strong><br/>
                      <span className="font-medium">
                        {selectedCargo.storage_fee_id ? getStorageFeeName(selectedCargo.storage_fee_id) : '-'}
                      </span>
                    </p>
                    <p><strong>Төлбөрийн байршил:</strong><br/>
                      <span className="font-medium">
                        {selectedCargo.payment_location_id ? getPaymentLocationName(selectedCargo.payment_location_id) : '-'}
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              {/* ТӨЛӨВИЙН ӨӨРЧЛӨЛТИЙН ТҮҮХ - COMPACT TIMELINE */}
              <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm mb-6">
                <div className="flex items-center justify-between mb-3">
                  <h5 className="text-base font-semibold text-gray-800 flex items-center gap-2">
                    <FaHistory className="text-blue-600 text-sm" />
                    Төлөвийн түүх
                  </h5>
                  {!loadingHistory && cargoStatusHistory.length > 0 && (
                    <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                      {cargoStatusHistory.length} өөрчлөлт
                    </span>
                  )}
                </div>
                
                {loadingHistory ? (
                  <div className="flex justify-center items-center py-6">
                    <div className="loading-spinner"></div>
                    <span className="ml-2 text-sm text-gray-500">Ачаалж байна...</span>
                  </div>
                ) : cargoStatusHistory.length === 0 ? (
                  <div className="text-center py-6 text-gray-400 text-sm">
                    <FaInfoCircle className="inline mb-1" /> Түүх байхгүй
                  </div>
                ) : (
                  <div className="overflow-x-auto history-scroll pb-2">
                    <div className="flex gap-3 min-w-max">
                      {cargoStatusHistory.map((history, index) => (
                        <div 
                          key={history.id}
                          className="history-card bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-3 min-w-[220px] max-w-[220px] flex-shrink-0 hover:shadow-md transition-shadow"
                        >
                          {/* Header */}
                          <div className="flex items-center justify-between mb-2">
                            <span className="w-6 h-6 bg-blue-600 text-white rounded-full flex items-center justify-center text-xs font-bold">
                              {cargoStatusHistory.length - index}
                            </span>
                            <span className="text-[10px] text-gray-500">
                              {new Date(history.changed_at).toLocaleDateString('mn-MN', { 
                                month: 'numeric', 
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </span>
                          </div>

                          {/* Status Change */}
                          <div className="mb-2">
                            {history.old_status ? (
                              <div className="flex items-center gap-1 text-xs">
                                <span className="px-2 py-0.5 bg-gray-200 text-gray-700 rounded font-medium truncate">
                                  {getStatusLabel(history.old_status)}
                                </span>
                                <svg className="w-3 h-3 text-blue-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                                <span className="px-2 py-0.5 bg-blue-600 text-white rounded font-medium truncate">
                                  {getStatusLabel(history.new_status)}
                                </span>
                              </div>
                            ) : (
                              <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-600 text-white rounded text-xs font-medium">
                                <FaCheckCircle className="text-[10px]" />
                                {getStatusLabel(history.new_status)}
                              </span>
                            )}
                          </div>

                          {/* Notes */}
                          {history.notes && (
                            <p className="text-[11px] text-gray-600 leading-tight mb-2 line-clamp-2">
                              {history.notes}
                            </p>
                          )}

                          {/* User */}
                          <div className="flex items-center gap-1 pt-2 border-t border-blue-200">
                            <FaUser className="text-blue-600 text-[10px]" />
                            <span className="text-xs text-blue-700 font-medium truncate">
                              {history.changed_by}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* 🆕 SMS ТҮҮХ -  */}
              <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm mb-6">
                <div className="flex items-center justify-between mb-3">
                  <h5 className="text-base font-semibold text-gray-800 flex items-center gap-2">
                    <FaMobileAlt className="text-green-600 text-sm" />
                    SMS Түүх
                  </h5>
                  {!loadingSmsHistory && smsHistory.length > 0 && (
                    <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                      {smsHistory.length} SMS
                    </span>
                  )}
                </div>
                
                {loadingSmsHistory ? (
                  <div className="flex justify-center items-center py-6">
                    <div className="loading-spinner"></div>
                    <span className="ml-2 text-sm text-gray-500">Ачааллаж байна...</span>
                  </div>
                ) : smsHistory.length === 0 ? (
                  <div className="text-center py-6 text-gray-400 text-sm">
                    <FaInfoCircle className="inline mb-1" /> SMS илгээгдээгүй байна
                  </div>
                ) : (
                  <div className="space-y-3 max-h-36 overflow-y-auto pr-2">                    
                    {smsHistory.map((sms, index) => (
                      <div 
                        key={sms.id}
                        className="border-l-4 border-blue-500 bg-blue-50 p-3 rounded-r-lg hover:shadow-md transition-shadow"
                      >
                        {/* Header */}
                        <div className="flex items-center justify-between mb-2">
                          <div className="flex items-center gap-2">
                            {sms.status === 'sent' ? (
                              <span className="px-2 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded flex items-center gap-1">
                                <FaCheckCircle /> Илгээсэн
                              </span>
                            ) : sms.status === 'failed' ? (
                              <span className="px-2 py-1 bg-red-100 text-red-700 text-xs font-semibold rounded flex items-center gap-1">
                                <FaExclamationTriangle /> Алдаатай
                              </span>
                            ) : (
                              <span className="px-2 py-1 bg-orange-100 text-orange-700 text-xs font-semibold rounded flex items-center gap-1">
                                <FaClock /> Хүлээгдэж байна
                              </span>
                            )}
                            <span className="text-xs text-gray-500">
                              #{smsHistory.length - index}
                            </span>
                          </div>
                          <span className="text-xs text-gray-500">
                            {new Date(sms.created_at).toLocaleString('mn-MN', {
                              month: 'short',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </span>
                        </div>

                        {/* Content */}
                        <div className="space-y-2 text-sm">
                          <div className="flex items-start gap-2">
                            <FaPhone className="text-blue-600 mt-1 flex-shrink-0" />
                            <div>
                              <span className="font-semibold text-gray-700">{sms.recipient_phone}</span>
                            </div>
                          </div>
                          
                          <div className="bg-white p-2 rounded border text-gray-800 text-xs">
                            {sms.message_body}
                          </div>

                          {sms.sent_at && (
                            <div className="flex items-center gap-2 text-xs text-green-700">
                              <FaCheckCircle />
                              <span>Илгээгдсэн: {new Date(sms.sent_at).toLocaleString('mn-MN')}</span>
                            </div>
                          )}

                          {sms.created_by_name && (
                            <div className="flex items-center gap-2 text-xs text-gray-600">
                              <FaUser />
                              <span>Үүсгэсэн: {sms.created_by_name}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* ТАЙЛБАР */}
              {selectedCargo.description && (
                <div className="bg-gray-50 p-5 rounded-xl mb-6 border border-gray-200 shadow-md">
                  <h5 className="text-md font-semibold text-gray-700 mb-3 flex items-center gap-2">
                    <FaInfoCircle className="text-gray-500" />
                    Нэмэлт тайлбар
                  </h5>
                  <p className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed bg-white p-4 rounded-lg shadow-inner">
                    {selectedCargo.description}
                  </p>
                </div>
              )}
              {/* 🆕 ТӨЛБӨРИЙН ТАЙЛБАР */}
                {selectedCargo.distribution_notes && (
                  <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-lg mb-6 shadow-md">
                    <div className="flex items-start gap-3">
                      <FaMoneyBillWave className="text-yellow-600 text-xl mt-1 flex-shrink-0" />
                      <div className="flex-1">
                        <h5 className="text-md font-bold text-yellow-800 mb-2">Төлбөрийн тайлбар</h5>
                        <p className="text-sm text-yellow-700 whitespace-pre-wrap leading-relaxed bg-white p-3 rounded-lg shadow-inner">
                          {selectedCargo.distribution_notes}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

              {/* БАРКОД */}
              <div className="bg-white border-2 border-gray-300 rounded-xl p-6 shadow-lg">
                <h5 className="text-lg font-semibold text-gray-800 mb-5 text-center flex items-center justify-center gap-2">
                  <FaBarcode className="text-blue-600" />
                  Ачааны баркод
                </h5>
          
                {selectedCargo.cargo_codes && selectedCargo.cargo_codes.length > 0 ? (
                  <div className="overflow-x-auto flex flex-row gap-6 pb-4">
                    {selectedCargo.cargo_codes.map((code, index) => (
                      <div key={index} className="bg-gradient-to-b from-gray-50 to-white border border-gray-200 rounded-lg p-5 text-center shadow-md hover:shadow-xl transition-shadow duration-300 min-w-[200px]">
                        <p className="text-xs font-semibold text-gray-600 mb-3">
                          Ширхэг {index + 1} / {selectedCargo.cargo_codes.length}
                        </p>
                        <div className="bg-white p-4 rounded-md mb-4 border shadow-sm flex justify-center items-center min-h-[120px]">
                          <svg id={`barcode-${index}`} className="max-w-full h-auto"></svg>
                        </div>
                        <p className="text-sm font-mono font-bold text-gray-900 tracking-wider bg-gray-100 px-2 py-1 rounded">
                          {code}
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-center text-gray-500 py-8">Баркод үүсгэх боломжгүй</p>
                )}
              </div>
            </div>

            <div className="modal-footer no-print bg-gray-50 border-t rounded-b-xl p-4 flex justify-between">
              <button
                onClick={() => {
                  setShowDetailModal(false);
                  setSelectedCargo(null);
                }}
                className="custom-button-secondary flex items-center"
              >
                <FaTimes className="mr-2" /> Хаах
              </button>
              <button
                onClick={() => window.print()}
                className="custom-button flex items-center"
              >
                <FaPrint className="mr-2" /> Хэвлэх
              </button>
            </div>
          </div>
        </div>
      )}

            {/* БАРИМТ-1 MODAL - A5 БОСОО */}
            {/* БАРИМТ-1 MODAL - A5 БОСОО ШИНЭЧИЛСЭН */}
            {showReceipt1Modal && selectedCargo && (
              <div className="modal-overlay" onClick={() => setShowReceipt1Modal(false)}>
                <div className="receipt1-container" onClick={(e) => e.stopPropagation()}>
                  <div className="receipt1-content">
                    {/* HEADER - ЛОГО */}
                    <div className="receipt1-header">
                      <img src="/logo.png" alt="Logo" className="receipt1-logo" />
                      <div className="receipt1-company">
                        <h1>ЖИМ-ГҮН КАРГО</h1>
                        <p className="receipt1-korean">집곤트레이드(주)</p>
                      </div>
                    </div>

                    {/* АЧААНЫ КОД */}
                    <div className="receipt1-cargo-code">
                      <span>Ачааны дугаар:</span>
                      <strong>{selectedCargo.cargo_code?.split(' ')[0] || selectedCargo.cargo_code}</strong>
                    </div>

                    {/* ИЛГЭЭГЧ БА ХҮЛЭЭН АВАГЧ - ХҮСНЭГТ */}
                    <table className="receipt1-table">
                      <tbody>
                        <tr>
                          <td className="receipt1-label" style={{ width: '15%' }}>Илгээгч:</td>
                          <td className="receipt1-value" style={{ width: '35%' }}>{selectedCargo.sender_name}</td>
                          <td className="receipt1-label" style={{ width: '15%' }}>Хүлээн авагч:</td>
                          <td className="receipt1-value" style={{ width: '35%' }}>{selectedCargo.receiver_name}</td>
                        </tr>
                        <tr>
                          <td className="receipt1-label" style={{ width: '15%' }}>Утас:</td>
                          <td className="receipt1-value" style={{ width: '35%' }}>{selectedCargo.sender_phone || '-'}</td>
                          <td className="receipt1-label" style={{ width: '15%' }}>Утас:</td>
                          <td className="receipt1-value" style={{ width: '35%' }}>{selectedCargo.receiver_phone || '-'}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* АЧААНЫ МЭДЭЭЛЭЛ */}
                    <div className="receipt1-section-title" style={{ marginTop: '8px', marginBottom: '4px' }}>
                      Ачааны мэдээлэл
                    </div>
                    <table className="receipt1-table" style={{ marginBottom: '6px' }}>
                      <tbody>
                        <tr>
                          <td className="receipt1-label">Жин:</td>
                          <td className="receipt1-value">
                            {selectedCargo.cargo_type === 'weight' ? `${selectedCargo.weight_kg} кг` : '-'}
                          </td>
                        </tr>
                        <tr>
                          <td className="receipt1-label">Ширхэг:</td>
                          <td className="receipt1-value">{selectedCargo.total_pieces}</td>
                        </tr>
                        {selectedCargo.description && (
                          <tr>
                            <td className="receipt1-label">Тайлбар:</td>
                            <td className="receipt1-value">{selectedCargo.description}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* ТӨЛБӨРИЙН БАЙРШИЛ */}
                    <div className="receipt1-payment-location" style={{ marginBottom: '6px' }}>
                      <label className="receipt1-checkbox">
                        <input 
                          type="checkbox" 
                          checked={selectedCargo.payment_location_name === 'Солонгос'} 
                          readOnly 
                        />
                        <span>KR (Солонгост төлөх)</span>
                      </label>
                      <label className="receipt1-checkbox">
                        <input 
                          type="checkbox" 
                          checked={selectedCargo.payment_location_name === 'Монгол'} 
                          readOnly 
                        />
                        <span>MGL (Монголд төлөх)</span>
                      </label>
                    </div>

                    {/* НИЙТ ТӨЛБӨР */}
                    <div className="receipt1-total-price" style={{ marginBottom: '6px' }}>
                      <div className="receipt1-price-label">Төлбөр:</div>
                      <div className="receipt1-price-amount">
                        {(() => {
                          const cargoPrice = parseFloat(selectedCargo.is_manual_price ? selectedCargo.manual_price || '0' : selectedCargo.price || '0') || 0;
                          const storageFee = parseFloat(selectedCargo.storage_fee_amount || '0') || 0;
                          const total = cargoPrice + storageFee;
                          return `${total.toLocaleString()}${getCurrencySymbol(selectedCargo)}`;
                        })()}
                      </div>
                    </div>

                    {/* ОГНООНУУД */}
                    <table className="receipt1-table" style={{ marginBottom: '6px' }}>
                      <tbody>
                        <tr>
                          <td className="receipt1-label" style={{ width: '30%' }}>Бүртгэл:</td>
                          <td className="receipt1-value" style={{ width: '20%' }}>
                            {new Date(selectedCargo.registered_date).toLocaleDateString('mn-MN')}
                          </td>
                          <td className="receipt1-label" style={{ width: '30%' }}>Тараалт:</td>
                          <td className="receipt1-value" style={{ width: '20%' }}>
                            {selectedCargo.container_distribution_date 
                              ? new Date(selectedCargo.container_distribution_date).toLocaleDateString('mn-MN')
                              : '-'
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* АНХААРУУЛГА */}
                    <div className="receipt1-notice" style={{ marginBottom: '6px', fontSize: '10px', padding: '6px' }}>
                      Дамжин өнгөрч буй боомтын ачаалал, галт тэрэг, усан онгоцны хуваарь болон багтаамж, 
                      гаалийн ачаалал, давагдашгүй хүчин зүйл зэргээс шалтгаалж тараагдах огноо хуваарь 
                      өөрчлөгдөж болохыг анхаарна уу!
                    </div>

                    {/* ХОЛБОО БАРИХ - 3 БАГАНЫН ХҮСНЭГТ */}
                    <div className="receipt1-section-title" style={{ marginTop: '6px', marginBottom: '3px' }}>
                      Холбоо барих
                    </div>
                    <table className="receipt1-table" style={{ marginBottom: '4px' }}>
                      <tbody>
                        <tr style={{ backgroundColor: '#f3f4f6', fontWeight: '600' }}>
                          <td style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'center' }}>Солонгос</td>
                          <td style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'center' }}>Монгол</td>
                          <td style={{ padding: '3px 6px', fontSize: '10px', textAlign: 'center' }}>Бусад</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '2px 6px', fontSize: '10px' }}>{receiptInfo.receipt_phone_korea_1}</td>
                          <td style={{ padding: '2px 6px', fontSize: '10px' }}>{receiptInfo.receipt_phone_mongolia_1}</td>
                          <td style={{ padding: '2px 6px', fontSize: '10px' }}>{receiptInfo.receipt_phone_other_1}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '2px 6px', fontSize: '10px' }}>{receiptInfo.receipt_phone_korea_2}</td>
                          <td style={{ padding: '2px 6px', fontSize: '10px' }}>{receiptInfo.receipt_phone_mongolia_2}</td>
                          <td style={{ padding: '2px 6px', fontSize: '10px' }}>{receiptInfo.receipt_phone_other_2}</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '2px 6px', fontSize: '10px' }}>{receiptInfo.receipt_phone_korea_3}</td>
                          <td style={{ padding: '2px 6px', fontSize: '10px' }}>{receiptInfo.receipt_phone_mongolia_3}</td>
                          <td style={{ padding: '2px 6px', fontSize: '10px' }}>{receiptInfo.receipt_phone_other_3}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* БАНКНЫ МЭДЭЭЛЭЛ */}
                    <div className="receipt1-section-title" style={{ marginTop: '4px', marginBottom: '2px' }}> {/* 6px → 4px, 3px → 2px */}
                      Банкны мэдээлэл
                    </div>
                    <table style={{ 
                      width: '100%', 
                      borderCollapse: 'collapse', 
                      border: '1px solid #000',
                      marginBottom: '3px' /* 4px → 3px */
                    }}></table>
                    <table className="receipt1-table" style={{ marginBottom: '4px' }}>
                      <tbody>
                        <tr>
                          <td className="receipt1-label" style={{ padding: '2px 6px', width: '25%' }}>{receiptInfo.receipt_bank1_name}:</td>
                          <td className="receipt1-value" style={{ padding: '2px 6px', width: '25%' }}>{receiptInfo.receipt_bank1_account}</td>
                          <td className="receipt1-label" style={{ padding: '2px 6px', width: '25%' }}>{receiptInfo.receipt_bank2_name}:</td>
                          <td className="receipt1-value" style={{ padding: '2px 6px', width: '25%' }}>{receiptInfo.receipt_bank2_account}</td>
                        </tr>
                        <tr>
                          <td className="receipt1-label" style={{ padding: '2px 6px' }}>Дансны нэр:</td>
                          <td className="receipt1-value" colSpan="3" style={{ padding: '2px 6px' }}>{receiptInfo.receipt_account_holder}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* FOOTER BUTTONS */}
                    <div className="modal-footer no-print">
                      <button
                        onClick={() => {
                          setShowReceipt1Modal(false);
                          setSelectedCargo(null);
                        }}
                        className="custom-button-secondary"
                      >
                        <FaTimes className="mr-2" /> Хаах
                      </button>
                      <button
                        onClick={() => window.print()}
                        className="custom-button"
                      >
                        <FaPrint className="mr-2" /> Хэвлэх
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}


      {/* БАРИМТ-2 MODAL - A4 ДЭЭ/LANDSCAPE + ДООД/БАРКОД */}
        {showReceipt2Modal && selectedCargo && (
          <div className="modal-overlay" onClick={() => setShowReceipt2Modal(false)}>
            <div className="receipt2-container" onClick={(e) => e.stopPropagation()}>
              <div className="receipt2-wrapper">
                {/* ДЭЭД ХЭСЭГ - LANDSCAPE */}
                <div className="receipt2-top-section">
                  {/* HEADER */}
                  <div className="receipt2-header">
                    <div className="receipt2-logo-section">
                      <img src="/logo.png" alt="Logo" className="receipt2-logo" />
                      <div className="receipt2-company">
                        <h1>ЖИМ-ГҮН КАРГО</h1>
                        <p className="receipt2-korean">집곤트레이드(주)</p>
                      </div>
                    </div>
                    <div className="receipt2-contact">
                      <div className="receipt2-contact-col">
                        <div className="receipt2-contact-title">tell kor:</div>
                        <div>{receiptInfo.receipt_phone_korea_1}</div>
                        <div>{receiptInfo.receipt_phone_korea_2}</div>
                        <div>{receiptInfo.receipt_phone_korea_3}</div>
                      </div>
                      <div className="receipt2-contact-col">
                        <div className="receipt2-contact-title">tell mon:</div>
                        <div>{receiptInfo.receipt_phone_mongolia_1}</div>
                        <div>{receiptInfo.receipt_phone_mongolia_2}</div>
                        <div>{receiptInfo.receipt_phone_mongolia_3}</div>
                      </div>
                    </div>
                  </div>

                  {/* TITLE */}
                  <div className="receipt2-title" style={{ marginBottom: '4px' }}> {/* 8px → 4px */}
                    <h2>Төлбөрийн баримт</h2>
                    <div className="receipt2-cargo-info" style={{ marginTop: '2px' }}> {/* ШИНЭ */}
                      <span>Ачааны дугаар: <strong>{selectedCargo.cargo_code?.split(' ')[0] || selectedCargo.cargo_code}</strong></span>
                      <span>{new Date(selectedCargo.registered_date).toLocaleDateString('mn-MN', { 
                        year: 'numeric', month: 'long', day: 'numeric' 
                      })}</span>
                    </div>
                  </div>

                  {/* MAIN CONTENT */}
                  <div className="receipt2-main-grid" style={{ gap: '6px', marginTop: '4px' }}>
                    {/* ИЛГЭЭГЧ */}
                    <div className="receipt2-party-box" style={{ padding: '6px' }}>
                      <div className="receipt2-party-header">
                        <div>Илгээгч</div>
                        <div className="receipt2-small">보내는사람 / From</div>
                      </div>
                      <div className="receipt2-party-content">
                        <div className="receipt2-field">
                          <span>нэр</span>
                          <span>{selectedCargo.sender_name}</span>
                        </div>
                        <div className="receipt2-field">
                          <span>утас</span>
                          <span>{selectedCargo.sender_phone || '-'}</span>
                        </div>
                      </div>
                    </div>

                    {/* ХҮЛЭЭН АВАГЧ */}
                    <div className="receipt2-party-box">
                      <div className="receipt2-party-header">
                        <div>Хүлээн авагч</div>
                        <div className="receipt2-small">받는사람 / To</div>
                      </div>
                      <div className="receipt2-party-content">
                        <div className="receipt2-field">
                          <span>нэр</span>
                          <span>{selectedCargo.receiver_name}</span>
                        </div>
                        <div className="receipt2-field">
                          <span>утас</span>
                          <span>{selectedCargo.receiver_phone || '-'}</span>
                        </div>
                      </div>
                    </div>

                    {/* ТӨЛБӨР */}
                    <div className="receipt2-party-box">
                      <div className="receipt2-party-header">
                        <div>Төлбөр төлөх байршил</div>
                        <div className="receipt2-small">운송료 / Shipping fee</div>
                      </div>
                      <div className="receipt2-party-content">  
                        <div className="receipt2-payment-checks">
                          <label>
                            <input 
                              type="checkbox" 
                              checked={selectedCargo.payment_location_name === 'Солонгос'} 
                              readOnly 
                            />
                            <span>Солонгос (KR)</span>
                          </label>
                          <label>
                            <input 
                              type="checkbox" 
                              checked={selectedCargo.payment_location_name === 'Монгол'} 
                              readOnly 
                            />
                            <span>Монгол (MGL)</span>
                          </label>
                        </div>
                        <div className="receipt2-weight-display">
                          {selectedCargo.cargo_type === 'weight' 
                            ? `${selectedCargo.weight_kg}kg` 
                            : `${parseFloat(selectedCargo.volume_cbm || 0).toFixed(4)}m³`
                          }
                        </div>
                      </div>
                    </div>

                    {/* ҮНЭЛГЭЭ ШИРХЭГ */}
                    <div className="receipt2-party-box">
                      <div className="receipt2-party-header">
                        <div>Үнэлгээ / Ширхэг</div>
                        <div className="receipt2-small">가격 / 수량</div>
                      </div>
                      <div className="receipt2-party-content">
                        <div className="receipt2-field">
                          <span>Price</span>
                          <span className="receipt2-price-value">
                            {parseFloat(selectedCargo.price || 0).toLocaleString()}
                            {getCurrencySymbol(selectedCargo)}
                          </span>
                        </div>
                        <div className="receipt2-field">
                          <span>Quantity</span>
                          <span className="receipt2-quantity">{selectedCargo.total_pieces}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ТАЙЛБАР */}
                  <div className="receipt2-description-box">
                    <div className="receipt2-desc-label">
                      <div>Тэмдэглэл</div>
                      <div className="receipt2-small">내용 / Contents</div>
                    </div>
                    <div className="receipt2-desc-value">
                      {selectedCargo.description || '-'}
                    </div>
                  </div>
                  <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: '1fr 1fr', 
                    gap: '6px', 
                    marginTop: '4px', /* 6px → 4px */
                    fontSize: '9px' /* 10px → 9px */
                  }}>
                    <div style={{ 
                      border: '1px solid #000', 
                      padding: '3px 5px', /* 4px 6px → 3px 5px */
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <span style={{ fontWeight: '600' }}>Бүртгэл:</span>
                      <span>{new Date(selectedCargo.registered_date).toLocaleDateString('mn-MN', {
                        year: '2-digit', month: '2-digit', day: '2-digit'
                      })}</span>
                    </div>
                    <div style={{ 
                      border: '1px solid #000', 
                      padding: '3px 5px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}>
                      <span style={{ fontWeight: '600' }}>Тараалт:</span>
                      <span>
                        {selectedCargo.container_distribution_date 
                          ? new Date(selectedCargo.container_distribution_date).toLocaleDateString('mn-MN')
                          : '-'
                        }
                      </span>
                    </div>
                  </div>

                  {/* ТЭЭВРИЙН ТӨРӨЛ */}
                  <div className="receipt2-transport-box">
                    <div className="receipt2-transport-label">
                      <div>Тээвэр төрөл</div>
                      <div className="receipt2-small">운송선택 / Transfer</div>
                    </div>
                    <div className="receipt2-transport-checks">
                      <label>
                        <input 
                          type="checkbox" 
                          checked={selectedCargo.container_type === 'normal'} 
                          readOnly 
                        />
                        <div>
                          <div>Энгийн</div>
                          <div className="receipt2-small">해상 SHIP</div>
                        </div>
                      </label>
                      <label>
                        <input 
                          type="checkbox" 
                          checked={selectedCargo.container_type === 'express'} 
                          readOnly 
                        />
                        <div>
                          <div>Экспрэсс</div>
                          <div className="receipt2-small">익스프레스 EXPRESS</div>
                        </div>
                      </label>
                    </div>
                  </div>

                  {/* САНАМЖ - БАГАСГАСАН */}
                  <div className="receipt2-notice-box" style={{ marginTop: '6px', padding: '6px' }}>
                    <div className="receipt2-notice-title" style={{ fontSize: '10px', marginBottom: '4px' }}>САНАМЖ</div>
                    <ul className="receipt2-notice-list" style={{ fontSize: '8px', lineHeight: '1.3', margin: '0', paddingLeft: '15px' }}>
                      <li style={{ marginBottom: '2px' }}>Шууданд тэсэрч дэлбэрэх эрсдэлтэй аюултай ачааг илгээхийг хориглоно!</li>
                      <li style={{ marginBottom: '2px' }}>Шууданг мэдэгдснээс хойш 7 хоногийн дотор хүлээн авах ба хайрцаг тутмаас хугацаа хэтэрсэн хоногийн 500 төг хадгалалтын хөлс төлөхийг анхаарна уу!</li>
                      <li style={{ marginBottom: '2px' }}>Та барааны тоо ширхэг үнэ маркыг үнэн зөв мэдүүлнэ үү!</li>
                    </ul>
                  </div>

                  {/* БАНКНЫ МЭДЭЭЛЭЛ */}
                  <div className="receipt1-section-title" style={{ marginTop: '6px', marginBottom: '3px' }}>
                    Банкны мэдээлэл
                  </div>
                  <table style={{ 
                    width: '100%', 
                    borderCollapse: 'collapse', 
                    border: '1px solid #000',
                    marginBottom: '4px'
                  }}>
                    <tbody>
                      <tr>
                        <td style={{ 
                          padding: '2px 4px', 
                          border: '1px solid #000',
                          fontWeight: '600',
                          background: '#f5f5f5',
                          width: '25%',
                          fontSize: '8pt'
                        }}>
                          {receiptInfo.receipt_bank1_name}:
                        </td>
                        <td style={{ 
                          padding: '2px 4px', 
                          border: '1px solid #000',
                          fontFamily: "'Courier New', monospace",
                          width: '25%',
                          fontSize: '8pt'
                        }}>
                          {receiptInfo.receipt_bank1_account}
                        </td>
                        <td style={{ 
                          padding: '2px 4px', 
                          border: '1px solid #000',
                          fontWeight: '600',
                          background: '#f5f5f5',
                          width: '25%',
                          fontSize: '8pt'
                        }}>
                          {receiptInfo.receipt_bank2_name}:
                        </td>
                        <td style={{ 
                          padding: '2px 4px', 
                          border: '1px solid #000',
                          fontFamily: "'Courier New', monospace",
                          width: '25%',
                          fontSize: '8pt'
                        }}>
                          {receiptInfo.receipt_bank2_account}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ 
                          padding: '2px 4px', 
                          border: '1px solid #000',
                          fontWeight: '600',
                          background: '#f5f5f5',
                          fontSize: '8pt'
                        }}>
                          Дансны нэр:
                        </td>
                        <td colSpan="3" style={{ 
                          padding: '2px 4px', 
                          border: '1px solid #000',
                          fontFamily: "'Courier New', monospace",
                          fontSize: '8pt'
                        }}>
                          {receiptInfo.receipt_account_holder}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* ДООД ХЭСЭГ - БАРКОДУУД */}
                <div className="receipt2-barcode-section">
                  <div className="receipt2-barcode-grid">
                    {selectedCargo.cargo_codes && selectedCargo.cargo_codes.map((code, index) => (
                      <div key={index} className="receipt2-barcode-card">
                        <svg id={`receipt2-barcode-${index}`} className="receipt2-barcode-svg"></svg>
                        <div className="receipt2-barcode-text">{code}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* FOOTER BUTTONS */}
              <div className="modal-footer no-print">
                <button
                  onClick={() => {
                    setShowReceipt2Modal(false);
                    setSelectedCargo(null);
                  }}
                  className="custom-button-secondary"
                >
                  <FaTimes className="mr-2" /> Хаах
                </button>
                <button
                  onClick={() => window.print()}
                  className="custom-button"
                >
                  <FaPrint className="mr-2" /> Хэвлэх
                </button>
              </div>
            </div>
          </div>
        )}


      {/* IMAGE MODAL - FULL SCREEN IMAGE VIEWER */}
      {showImageModal && modalImages.length > 0 && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setShowImageModal(false)}
        >
          <button
            onClick={() => setShowImageModal(false)}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
          >
            <FaTimes className="w-8 h-8" />
          </button>

          {modalImages.length > 1 && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  previousImage();
                }}
                className="absolute left-4 text-white hover:text-gray-300 transition-colors z-10 bg-black bg-opacity-50 rounded-full p-3"
              >
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  nextImage();
                }}
                className="absolute right-4 text-white hover:text-gray-300 transition-colors z-10 bg-black bg-opacity-50 rounded-full p-3"
              >
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </>
          )}

          <div 
            className="relative max-w-7xl max-h-[90vh] w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={`${window.location.origin}${modalImages[selectedImageIndex]}`}
              alt={`Image ${selectedImageIndex + 1}`}
              className="w-full h-auto max-h-[90vh] object-contain rounded-lg"
              onError={(e) => { e.target.src = 'https://via.placeholder.com/800?text=Image+Not+Found' }}
            />
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white px-4 py-2 rounded-full">
              {selectedImageIndex + 1} / {modalImages.length}
            </div>
          </div>

          <div className="absolute bottom-4 left-4 text-white text-sm bg-black bg-opacity-50 px-3 py-2 rounded">
            ← → товчоор солих
          </div>
        </div>
      )}
    </div>
  );
};

export default CargoManagement;